<template>
    <div class="checkout_session" v-if="cart.items.length > 0" :key="'isCheckoutPageCount'+isCheckoutPageCount">

        <div class="checkout_flow_arrow" id="checkout_flow_arrow" @click="$root.FlowArrowClick();">
            <div class="arrow_div"></div>
        </div>

        <div class="checkout_back_area display_responsive">
            <div class="back_btn_div" @click="continue_shopping()">
                <div class="back_btn"></div>
            </div>
        </div>

        <!-- checkout div start -->
        <div class="checkout_main_area" v-if="isCheckoutPage">

            <div class="checkout_back_area display_desktop">
                <div class="back_btn_div" @click="continue_shopping()">
                    <div class="back_btn"></div>
                    <div class="back_text">{{label['continue_shopping_label']}}</div>
                </div>
            </div>

            <div class="checkout_shop_name_area">
                {{ displayShop['name'+getItemSubfix()] }}
            </div>

            <div class="checkout_content_area">

                <div class="checkout_order_info_main_area">

                    <div class="checkout_info_area" v-if="!$root.CheckOrderModeIsShopping || $root.CheckOrderOrderTypeIdx(cart) == 1">
                        <div class="info_header_div" v-if="$root.CheckOrderOrderTypeIdx(cart) == 1">{{$root.GetOrderModePickupTypeLabel(1,cart.orderMode)}}{{label['checkout_header_information_text_ending']}}</div>
                        <div class="info_header_div" v-if="$root.CheckOrderOrderTypeIdx(cart) == 2">{{$root.GetOrderModePickupTypeLabel(2,cart.orderMode)}}{{label['checkout_header_information_text_ending']}}</div>
                        <div class="info_header_div" v-if="$root.CheckOrderOrderTypeIdx(cart) == 3">{{$root.GetOrderModePickupTypeLabel(3,cart.orderMode)}}{{label['checkout_header_information_text_ending']}}</div>

                        <div class="select_address_area" 
                             :class="{noOption: !($root.CheckOrderOrderTypeIdx(cart) == 1 && info.order_setting.needDeliveryRemarks)}" 
                             @click="OpenCheckoutModifyAddress()"
                             v-if="$root.CheckOrderOrderTypeIdx(cart) == 1">

                            <div class="address_display_div" v-if="info.order_temp_info.order_address != null">
                                <div class="address_display_contact" v-if="info.order_temp_info.order_contact_info != null">
                                    <span v-if="info.order_temp_info.order_address_tag != undefined && info.order_temp_info.order_address_tag != ''">{{info.order_temp_info.order_address_tag}}．</span>{{info.order_temp_info.order_contact_info['name']}}．+{{info.order_temp_info.order_contact_info['tel_countryCode']}}-{{info.order_temp_info.order_contact_info['tel']}}
                                </div>
                                <div class="address_display_address">{{info.order_temp_info.order_address['address_full_'+info.lang]}}</div>
                            </div>
                            <div class="address_display_div" v-if="info.order_temp_info.order_address == null">
                                <div class="address_display_contact" v-if="info.order_temp_info.order_contact_info != null">
                                    {{label['checkout_please_input_delivery_address']}}
                                </div>
                            </div>
                            <div class="address_display_edit_btn_div">
                                <div class="address_display_edit_btn" ></div>
                            </div>

                        </div>
                        <div class="select_address_area " 
                             :class="{
                             delivery: info.order_temp_info.order_type == 'delivery', 
                             pickup: info.order_temp_info.order_type == 'pickup', 
                             pickupShop: info.order_temp_info.order_type == 'pickupShop', 
                             modify: ($root.CheckOrderOrderTypeIdx(cart) == 2)
                             }" 
                             @click="openShopChangeLayerPanel()"
                             v-if="$root.CheckOrderOrderTypeIdx(cart) == 2 || $root.CheckOrderOrderTypeIdx(cart) == 3">
                            <div class="address_display_div">
                                <div class="address_display_address">{{ displayShop['address'+getItemSubfix()] }}</div>
                            </div>
                            <div class="edit_btn_div" v-if="$root.CheckOrderOrderTypeIdx(cart) == 2">
                                <div class="edit_btn" ></div>
                            </div>
                        </div>
                        <!-- select_address_area end -->
                        
                        <div class="delivery_remark_select_area" v-if="($root.CheckOrderOrderTypeIdx(cart) == 1 && info.order_setting.needDeliveryRemarks)">

                            <div class="delivery_remark_display_row"
                                 @click="openDeliveryMessagePanel()"
                                 >
                                <div class="delivery_remark_display_area">
                                    <div class="delivery_remark_display_div">
                                        <div class="delivery_remark_display_text" :class="{isSelect: (cart.remarkDeliveryObj.length > 0 && !showDeliveryMessagePanel)}" v-html="getDeliveryMessagelabel()"></div>
                                    </div>
                                </div>
                                <div class="delivery_remark_display_edit_btn_div">
                                    <div class="delivery_remark_display_edit_btn" :class="{onselect : showDeliveryMessagePanel}" ></div>
                                </div>
                            </div>
                            <div class="delivery_remark_select_row">
                                <transition name="sliderDivFast">
                                    <div class="delivery_remark_select_option_div" v-if="showDeliveryMessagePanel">

                                        <div class="delivery_remark_select_option_row"
                                             v-for="(item, index) in DeliveryMessageList"
                                             :key="'DeliveryMessageList'+index"
                                             @click="setDeliveryMessage(item)"
                                             :class="{active: checkDeliveryMessageIsClick(item)}">

                                            <div class="tick_div"><div class="tick_icon"></div></div>
                                            <div class="option_name_div" :class="item.code">
                                                <div class="option_icon"></div>
                                                <div class="option_name">{{ item["msg_" + getItemSubfix()] }}</div>
                                            </div>

                                        </div>

                                    </div>
                                </transition>
                            </div>

                        </div>
                        <!-- delivery_remark_select_area end -->

                    </div>
                    <!-- checkout_cart_info_area -->


                    <div class="checkout_info_area" v-if="$root.CheckOrderOrderTypeIdx(cart) == 3">
                        <div class="info_header_div">{{label['checkout_select_delivery_method_header_shopping']}}</div>
                        <div class="delivery_remark_select_area single">
                            <div class="delivery_remark_display_row"
                                 @click="openShopChangeLayerPanel()">
                                <div class="delivery_remark_display_area">
                                    <div class="delivery_remark_display_div">
                                        <div class="delivery_remark_display_text isSelect">{{ label['order_mode_pickup_type_pickupShop_text'] }}
                                            <div class="sub_text" v-if="cart.pickupShop != null"> - {{cart.pickupShop["name" + getItemSubfix()]}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="delivery_remark_display_edit_btn_div">
                                    <div class="delivery_remark_display_edit_btn" ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="checkout_info_area" v-if="DeliveryMethodList.length > 0">
                        <div class="info_header_div" v-if="!$root.CheckOrderModeIsShopping">{{label['checkout_select_delivery_method_header']}}</div>
                        <div class="info_header_div" v-if="$root.CheckOrderModeIsShopping">{{label['checkout_select_delivery_method_header_shopping']}}</div>
                        
                        <div class="delivery_remark_select_area" :class="{single : lockerOptionLayerObj.lockerOption == '', muti: lockerOptionLayerObj.lockerOption != '', noborder: DeliveryMethodList.length <= 1}">

                            <div class="delivery_remark_display_row"
                                 @click="openDeliveryMethodPanel()">
                                <div class="delivery_remark_display_area">
                                    <div class="delivery_remark_display_div">
                                        <div class="delivery_remark_display_text" :class="{isSelect: (cart.deliveryMethod != null)}">{{ getDeliveryMethodlabel() }}</div>
                                    </div>
                                </div>
                                <div class="delivery_remark_display_edit_btn_div">
                                    <div class="delivery_remark_display_edit_btn" v-if="DeliveryMethodList.length > 1" :class="{onselect : showDeliveryMethodPanel}" ></div>
                                </div>
                            </div>
                            <div class="delivery_remark_select_row">
                                <transition name="sliderDivFast">
                                    <div class="delivery_remark_select_option_div" v-if="showDeliveryMethodPanel">

                                        <div class="delivery_remark_select_option_row"
                                             v-for="(item, index) in DeliveryMethodList"
                                             :key="'DeliveryMethodList'+index"
                                             @click="setDeliveryMethod(item)"
                                             :class="{active: (cart.deliveryMethod != null && item.code == cart.deliveryMethod.code)}">

                                            <div class="tick_div"><div class="tick_icon"></div></div>
                                            <div class="option_name_div" :class="item.code">
                                                <div class="option_icon"></div>
                                                <div class="option_name">{{ item["name" + getItemSubfix()] }}</div>
                                            </div>

                                        </div>

                                    </div>
                                </transition>
                            </div>

                        </div>


                        <div class="delivery_remark_select_area muti" v-if="lockerOptionLayerObj.lockerOption != ''">

                            <div class="delivery_remark_display_row"
                                 @click="openDeliveryMethodLockerOptionSelectLayer()">
                                <div class="delivery_remark_display_area">
                                    <div class="delivery_remark_display_div">
                                        <div class="delivery_remark_display_text" :class="{isSelect: (getDeliveryMethodLockerOptionDisplaylabelCheck() != null)}" v-html="getDeliveryMethodLockerOptionDisplaylabel()"></div>
                                    </div>
                                </div>
                                <div class="delivery_remark_display_edit_btn_div">
                                    <div class="delivery_remark_display_edit_btn" :class="{onselect : lockerOptionLayerObj.showLayer}" ></div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- checkout_payment_datetime_area -->


                    <div class="checkout_payment_datetime_area">
                        <div class="checkout_payment_datetime_header_div" v-if="!$root.CheckOrderModeIsShopping && $root.CheckOrderOrderTypeIdx(cart) == 1">{{label['checkout_delivery_time_header_text_delivery']}}</div>
                        <div class="checkout_payment_datetime_header_div" v-if="!$root.CheckOrderModeIsShopping && $root.CheckOrderOrderTypeIdx(cart) == 2">{{label['checkout_delivery_time_header_text_pickup']}}</div>
                        <div class="checkout_payment_datetime_header_div" v-if="$root.CheckOrderModeIsShopping && $root.CheckOrderOrderTypeIdx(cart) == 1">{{label['checkout_delivery_time_header_text_delivery_shopping']}}</div>
                        <div class="checkout_payment_datetime_header_div" v-if="$root.CheckOrderModeIsShopping && $root.CheckOrderOrderTypeIdx(cart) == 2">{{label['checkout_delivery_time_header_text_pickup_shopping']}}</div>
                        <div class="checkout_payment_datetime_header_div" v-if="$root.CheckOrderModeIsShopping && $root.CheckOrderOrderTypeIdx(cart) == 3">{{label['checkout_delivery_time_header_text_pickup_shopping']}}</div>

                        <div class="checkout_payment_datetime_row">

                            <div class="datetime_display_div" v-if="!$root.CheckOrderModeIsShopping">
                                <div class="datetime_display_text" v-if="info.order_setting.order_time_select">
                                    {{info.order_temp_info.order_date}}
                                    <span class="order_readyTime_text" v-if="info.order_temp_info.order_time == 'asap'">．{{label["order_time_option_asap"]}}({{label['order_asap_estimate_time_label']}} {{ $root.OrderDateSelect.format('HH:mm') }})</span>
                                    <span class="order_readyTime_text" v-if="info.order_temp_info.order_time != 'asap'">({{label["order_normal_time_label"]}}: {{info.order_temp_info.order_time}})</span>
                                </div>
                                <div class="datetime_display_text" v-if="!info.order_setting.order_time_select">
                                    {{info.order_temp_info.order_date}}
                                </div>
                            </div>
                            <div class="datetime_display_div" v-if="$root.CheckOrderModeIsShopping">
                                <div class="datetime_display_text" v-if="$root.CheckOrderOrderTypeIdx(cart) == 2" v-html="label['checkout_orderType_pickup_time_text']">
                                </div>
                                <div class="datetime_display_text" v-if="$root.CheckOrderOrderTypeIdx(cart) == 3" v-html="label['checkout_orderType_pickupShop_time_text']">
                                </div>
                            </div>
                            <div class="datetime_display_edit_btn_div" style="display:none">
                                <div class="datetime_display_edit_btn" v-if="!info.order_setting.aspa_only" @click="$root.OpenOrderInfoEditLayer(checkoutOrderInfoEdit)"></div>
                            </div>

                        </div>
                    </div>
                    <!-- checkout_payment_datetime_area -->

                </div>

                <div class="checkout_cart_list_area" :key="'CheckoutListUpdate1'+CheckoutListUpdate">
                    <div class="cart_list_header_div" v-if="!$root.CheckOrderModeIsShopping">{{label['checkout_order_data_header_text']}}</div>
                    <div class="cart_list_header_div" v-if="$root.CheckOrderModeIsShopping">{{label['checkout_order_data_header_text_shopping']}}</div>

                    <div class="cart_list_area">
                        <div class="cart_item_list_div">

                            <CartListItem v-bind:cart="cart" v-bind:can_update="false">
                            </CartListItem>

                        </div>
                        <!-- cart_item_list_div -->

                        <div class="cart_use_discount_div">
                            <!-- ecash start -->
                            <div class="cart_use_discount_row" v-if="cart.member != null" style="display:none;">
                                <div class="discount_header_div">{{label['checkout_order_use_ecash_header_text']}}</div>
                                <div class="discount_input_div" :class="{'inUse' : UseECashObj.inUse, 'isError' : UseECashObj.isError }">
                                    <div class="discount_input_area">
                                        <input type="number"
                                               :placeholder="label['checkout_order_use_ecash_input_text_can_use'] + ' ' + cart.member.eCash"
                                               class="form-control"
                                               id="checkout_cart_ecash"
                                               autocomplete="off"
                                               v-model="UseECashObj.eCashUse"
                                               :readonly="UseECashObj.inUse" />
                                    </div>
                                    <div class="discount_btn_area">
                                        <div class="discount_btn" v-if="!UseECashObj.inUse" @click="UseECashCheckoutBtnClick()">{{label['checkout_order_use_ecash_use_text']}}</div>
                                        <div class="discount_btn" v-if="UseECashObj.inUse" @click="RemoveECashCheckoutBtnClick()">{{label['checkout_order_use_ecash_remove_text']}}</div>
                                    </div>
                                </div>
                                <div class="discount_error_msg_div" v-if="UseECashObj.isError">{{label['checkout_order_use_ecash_error_msg_text_not_enough_ecash']}}</div>
                                <div class="discount_error_msg_div isSuccess" v-if="UseECashObj.inUse"><div class="success_icon"></div>{{label['checkout_order_use_ecash_success_msg_text']}}</div>
                            </div>
                            <!-- ecash end-->


                            <!-- coupon with discount code start -->
                            <div class="" v-if="!$root.CheckOrderModeIsShopping && info.disableDiscountBtn" class="checkout_disableDiscountBtn" :class="{'active' : cart.disableDiscount}" @click="disableDiscountBtnClick">
                                {{label['checkout_disableDiscountBtn_text']}}
                            </div>

                            <div style="width:100%" v-if="cart.member != null">
                                <div class="checkout_discountcode" :class="{'disable' : cart.disableDiscount}">
                                    <div class="discountcode_title">
                                        {{CouponDiscountCodeLabel()}}
                                    </div>
                                    <div class="discountcode_checkout_div">
                                        <div class="discountcode_input_div" :class="{'inUse' : UseDiscountCodeObj.inUse, 'isError' : UseDiscountCodeObj.isError}">
                                            <div class="discountcode_input_area">
                                                <input type="text"
                                                       :placeholder="CouponDiscountCodeLabel()"
                                                       class="form-control"
                                                       :class="{'no_coupon' : !info.enableCouponCode}"
                                                       id="checkout_cart_discount_code"
                                                       autocomplete="off"
                                                       v-model="UseDiscountCodeObj.codeUse"
                                                       :readonly="(UseDiscountCodeObj.inUse || !checkCanUseDiscountCode())"
                                                       v-if="info.enableDiscountCode && CheckoutSelectCouponLayerObj.use_coupon.length <= 0" />
                                                <div class="coupon_display_div" v-if="!info.enableDiscountCode && CheckoutSelectCouponLayerObj.use_coupon.length <= 0">
                                                    <div class="coupon_row">
                                                        {{CouponDiscountCodeLabel()}}
                                                    </div>
                                                </div>
                                                <div class="coupon_display_div" v-if="CheckoutSelectCouponLayerObj.use_coupon.length > 0">
                                                    <div class="coupon_row"
                                                         v-for="(coup, index) in CheckoutSelectCouponLayerObj.use_coupon"
                                                         :key="'coup'+index">
                                                        {{coup['couponName' + getItemSubfix()]}}
                                                    </div>
                                                </div>
                                                <div v-if="info.enableCouponCode" class="coupon_select_icon" @click="OpenOrderCouponEditLayer()" :class="{'disable' : !checkCanUseCoupon()}" :alt="label['checkout_order_use_coupon_header_text']" :title="label['checkout_order_use_coupon_header_text']"></div>
                                            </div>
                                            <div class="discountcode_btn_area">
                                                <div class="discountcode_btn" v-if="(info.enableCouponCode && info.enableDiscountCode) && !UseDiscountCodeObj.inUse && CheckoutSelectCouponLayerObj.use_coupon.length <= 0" @click="UseDiscountCodeCheckoutBtnClick()">{{label['checkout_text_discountcode_apply']}}</div>
                                                <div class="discountcode_btn" v-if="(info.enableCouponCode && !info.enableDiscountCode) && !UseDiscountCodeObj.inUse && CheckoutSelectCouponLayerObj.use_coupon.length <= 0" @click="OpenOrderCouponEditLayer()">{{label['checkout_text_discountcode_apply']}}</div> <!-- for open coupon layer -->
                                                <div class="discountcode_btn" v-if="(!info.enableCouponCode && info.enableDiscountCode) && UseDiscountCodeObj.inUse && CheckoutSelectCouponLayerObj.use_coupon.length <= 0" @click="RemoveDiscountCodeCheckoutBtnClick()">{{label['checkout_text_discountcode_cancel']}}</div>
                                                <div class="discountcode_btn" v-if="(info.enableCouponCode) && CheckoutSelectCouponLayerObj.use_coupon.length > 0" @click="RemoveCouponUseBtnClick()">{{label['checkout_text_discountcode_cancel']}}</div>
                                            </div>
                                        </div>
                                        <div class="discountcode_invalid_msg" v-if="UseDiscountCodeObj.isError">{{label['checkout_text_discountcode_invalid']}}</div>
                                        <div class="discountcode_invalid_msg isSuccess" v-if="UseDiscountCodeObj.inUse">{{label['checkout_text_discountcode_valid']}}</div>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%" v-if="cart.member == null">
                                <div class="checkout_discountcode">
                                    <div class="discountcode_title">
                                        {{CouponDiscountCodeLabel()}}
                                    </div>
                                    <div class="discountcode_checkout_div">
                                        <div class="discountcode_input_div" :class="{'inUse' : UseDiscountCodeObj.inUse, 'isError' : UseDiscountCodeObj.isError}">
                                            <div class="discountcode_input_area">
                                                <input type="text"
                                                       :placeholder="CouponDiscountCodeLabel()"
                                                       class="form-control"
                                                       :class="'no_coupon'"
                                                       id="checkout_cart_discount_code"
                                                       autocomplete="off"
                                                       v-model="UseDiscountCodeObj.codeUse"
                                                       :readonly="(UseDiscountCodeObj.inUse || !checkCanUseDiscountCode())"
                                                       v-if="(info.enableDiscountCode) && CheckoutSelectCouponLayerObj.use_coupon.length <= 0" />
                                            </div>
                                            <div class="discountcode_btn_area">
                                                <div class="discountcode_btn" v-if="(info.enableDiscountCode) && !UseDiscountCodeObj.inUse && CheckoutSelectCouponLayerObj.use_coupon.length <= 0" @click="UseDiscountCodeCheckoutBtnClick()">{{label['checkout_text_discountcode_apply']}}</div>
                                                <div class="discountcode_btn" v-if="(info.enableDiscountCode) && UseDiscountCodeObj.inUse && CheckoutSelectCouponLayerObj.use_coupon.length <= 0" @click="RemoveDiscountCodeCheckoutBtnClick()">{{label['checkout_text_discountcode_cancel']}}</div>
                                                <!--<div class="discountcode_btn" v-if="(info.enableCouponCode) && CheckoutSelectCouponLayerObj.use_coupon.length > 0" @click="RemoveCouponUseBtnClick()">{{label['checkout_text_discountcode_cancel']}}</div>-->
                                            </div>
                                        </div>
                                        <div class="discountcode_invalid_msg" v-if="UseDiscountCodeObj.isError">{{label['checkout_text_discountcode_invalid']}}</div>
                                        <div class="discountcode_invalid_msg isSuccess" v-if="UseDiscountCodeObj.inUse">{{label['checkout_text_discountcode_valid']}}</div>
                                    </div>
                                </div>
                            </div>
                            <!-- coupon with discount code start -->

                        </div>

                    </div>

                    <!-- desktop version cart amount start -->
                    <div class="cart_list_area margin_top display_desktop">

                        <div class="cart_item_amount_div">

                            <div class="cart_item_amount_row" :class="{isAlert : checkMinChargeText() != ''}">
                                <div class="price_text">{{label['amount_label']}}</div>
                                <div class="price_amount">
                                    <!--<money :price="$root.sumItemListPrice(cart.items)" />-->
                                    <money :price="cart.amountWithoutDiscount" />
                                </div>
                            </div>
                            <div class="cart_item_amount_row isAlert" v-if="checkMinChargeText() != ''">
                                <div class="full_text">{{checkMinChargeText()}}</div>
                            </div>

                            <div class="cart_item_amount_row isAlert" v-if="cart.minCharge > 0">
                                <div class="price_text">{{label['cart_fit_minCharge_text']}}</div>
                                <div class="price_amount">
                                    <money :price="cart.minCharge" />
                                </div>
                            </div>

                            <div class="cart_item_amount_row" v-if="cart.packingCharge > 0">
                                <div class="price_text">{{label['cart_packingCharge_text']}}</div>
                                <div class="price_amount">
                                    <money :price="cart.packingCharge" />
                                </div>
                            </div>

                            <!-- load discount item start -->
                            <div class="cart_item_amount_row"
                                 v-for="(discount, index) in cart.discounts.filter(x => !x.isHide)"
                                 :key="'d'+index">
                                <div class="price_text">{{discount['name'+getItemSubfix()]}}</div>
                                <div class="price_amount">
                                    -<money :price="discount.price" />
                                </div>
                            </div>
                            <!-- load discount item end -->

                            <div class="cart_item_amount_row" v-if="cart.deliveryCharge > 0">
                                <div class="price_text">{{label['cart_deliveryCharge_text']}}</div>
                                <div class="price_amount">
                                    <money :price="cart.deliveryCharge" />
                                </div>
                            </div>

                            <div class="cart_item_amount_row" v-if="cart.usedECash > 0">
                                <div class="price_text">{{label['checkout_order_use_ecash_text_used_ecash']}}</div>
                                <div class="price_amount">
                                    -<money :price="cart.usedECash" />
                                </div>
                            </div>

                            <div class="cart_item_amount_row final_amount">
                                <div class="price_text">{{label['total_amount_label']}}</div>
                                <div class="price_amount">
                                    <money :price="cart.amount" />
                                </div>
                            </div>

                        </div>

                    </div>
                    <!-- desktop version cart amount end -->

                </div>

                <!-- checkout_cart_list_area -->
                <!--<div class="checkout_remark_area">
                    <div class="checkout_remark_header_div" v-if="!$root.CheckOrderModeIsShopping">{{label['checkout_order_remark_text']}}</div>
                    <div class="checkout_remark_header_div" v-if="$root.CheckOrderModeIsShopping">{{label['checkout_order_remark_text_shopping']}}</div>
                    <div class="checkout_remark_input_div have_border">
                        <textarea maxlength="100" class="checkout_remark_input" :placeholder="label['checkout_order_remark_text']" v-model="orderRemark"></textarea>
                    </div>
                </div>-->

                <div class="checkout_payment_area" v-if="cart.amount > 0">
                    <div class="checkout_payment_header_div">
                        {{label['checkout_payment_method_header_text']}}
                        <!--<span class="right_text">{{label['checkout_payment_method_header_subtext']}}</span>-->
                    </div>

                    <div class="payment_select_area display_desktop">

                        <div class="payment_select_row">
                            <transition name="sliderDiv">
                                <div class="payment_select_option_div">
                                    <!--
                                    <div class="payment_select_option_row"
                                         @click="setPayMethodNormal(null)"
                                         :class="{active: payMethod == undefined}">

                                        <div class="tick_div"><div class="tick_icon"></div></div>
                                        <div class="option_name_div" :class="''">
                                            <div class="option_name">
                                                <div class="payment_select_layer_text_div">
                                                    <div class="text_div">{{ label['checkout_please_select_payment_method_text'] }}</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    -->
                                    <div class="payment_select_option_row"
                                         v-for="(item, index) in payMethodList"
                                         :key="'payMethodList'+index"
                                         @click="setPayMethodNormal(item)"
                                         :class="{active: ($root.tempPaymentMethod != undefined && item.code == $root.tempPaymentMethod.code), disable : !checkPayMethodInCoupon(item)}">

                                        <div class="tick_div"><div class="tick_icon"></div></div>
                                        <div class="option_name_div" :class="item.code">
                                            <div class="option_icon" :style="{'background-image':'url(\''+item.image+'\')'}"></div>
                                            <div class="option_name">
                                                <div class="payment_select_layer_text_div">
                                                    <div class="text_div">{{ item["name" + getItemSubfix()] }}</div>
                                                    <div class="icon_div master_card" v-if="item.code == 'cybersource'"><img src="/files/images/main/payment_ico_master.png" align="absmiddle" /></div>
                                                    <div class="icon_div visa_card" v-if="item.code == 'cybersource'"><img src="/files/images/main/payment_ico_visa_secure.png" align="absmiddle" /></div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </transition>
                        </div>

                    </div>
                    <div class="payment_select_area display_responsive">

                        <div class="payment_display_row" @click="openPayMethodPanelLayer()">
                            <div class="payment_display_area" v-if="$root.tempPaymentMethod == undefined">
                                <div class="payment_display_div" :class="''">
                                    <div class="payment_display_icon" :style="{'background-image':null}" style="width:0;"></div>
                                    <div class="payment_display_text">
                                        <div class="payment_select_layer_text_div gray">
                                            <div class="text_div gray">{{ label['checkout_please_select_payment_method_text'] }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="payment_display_area" v-if="$root.tempPaymentMethod != undefined">
                                <div class="payment_display_div" :class="$root.tempPaymentMethod.code">
                                    <div class="payment_display_icon" :style="{'background-image':'url(\''+$root.tempPaymentMethod.image+'\')'}"></div>
                                    <div class="payment_display_text">
                                        <div class="payment_select_layer_text_div">
                                            <div class="text_div">{{ $root.tempPaymentMethod["name" + getItemSubfix()] }}</div>
                                            <div class="icon_div master_card" v-if="$root.tempPaymentMethod.code == 'cybersource'"><img src="/files/images/main/payment_ico_master.png" align="absmiddle" /></div>
                                            <div class="icon_div visa_card" v-if="$root.tempPaymentMethod.code == 'cybersource'"><img src="/files/images/main/payment_ico_visa_secure.png" align="absmiddle" /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="payment_display_edit_btn_div">
                                <div class="payment_display_edit_btn" :class="{onselect : showPayMethodPanelLayer}"></div>
                            </div>
                        </div>

                    </div>

                </div>
                <!-- checkout_cart_list_area -->

                <!-- responsive version cart amount start -->
                <div class="checkout_cart_list_area display_responsive" :key="'CheckoutListUpdate2'+CheckoutListUpdate">
                    <div class="cart_list_area">

                        <div class="cart_item_amount_div">

                            <div class="cart_item_amount_row" :class="{isAlert : checkMinChargeText() != ''}">
                                <div class="price_text">{{label['amount_label']}}</div>
                                <div class="price_amount">
                                    <!--<money :price="$root.sumItemListPrice(cart.items)" />-->
                                    <money :price="cart.amountWithoutDiscount" />
                                </div>
                            </div>
                            <div class="cart_item_amount_row isAlert" v-if="checkMinChargeText() != ''">
                                <div class="full_text">{{checkMinChargeText()}}</div>
                            </div>

                            <div class="cart_item_amount_row isAlert" v-if="cart.minCharge > 0">
                                <div class="price_text">{{label['cart_fit_minCharge_text']}}</div>
                                <div class="price_amount">
                                    <money :price="cart.minCharge" />
                                </div>
                            </div>

                            <div class="cart_item_amount_row" v-if="cart.packingCharge > 0">
                                <div class="price_text">{{label['cart_packingCharge_text']}}</div>
                                <div class="price_amount">
                                    <money :price="cart.packingCharge" />
                                </div>
                            </div>

                            <!-- load discount item start -->
                            <div class="cart_item_amount_row"
                                 v-for="(discount, index) in cart.discounts.filter(x => !x.isHide)"
                                 :key="'d'+index">
                                <div class="price_text">{{discount['name'+getItemSubfix()]}}</div>
                                <div class="price_amount">
                                    -<money :price="discount.price" />
                                </div>
                            </div>
                            <!-- load discount item end -->

                            <div class="cart_item_amount_row" v-if="cart.deliveryCharge > 0">
                                <div class="price_text">{{label['cart_deliveryCharge_text']}}</div>
                                <div class="price_amount">
                                    <money :price="cart.deliveryCharge" />
                                </div>
                            </div>

                            <div class="cart_item_amount_row" v-if="cart.usedECash > 0">
                                <div class="price_text">{{label['checkout_order_use_ecash_text_used_ecash']}}</div>
                                <div class="price_amount">
                                    -<money :price="cart.usedECash" />
                                </div>
                            </div>

                            <div class="cart_item_amount_row final_amount">
                                <div class="price_text">{{label['total_amount_label']}}</div>
                                <div class="price_amount">
                                    <money :price="cart.amount" />
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <!-- responsive version cart amount end -->

                <div class="checkout_remark_area">

                    <div class="checkout_staff_customer_info_area" v-if="isStaffAccount">
                        <div class="checkout_staff_customer_info_area_header_div">{{label['checkout_order_customer_info_header']}}</div>
                        <div class="checkout_remark_input_div">
                            <input type="text" autocomplete="off" class="checkout_remark_input" :placeholder="label['checkout_order_customer_name_text']" v-model="customerInfo.orderCustomerName"></input>
                        </div>
                        <div class="checkout_remark_input_div">
                            <input type="text" autocomplete="off" class="checkout_remark_input" :placeholder="label['checkout_order_customer_email_text']" v-model="customerInfo.orderCustomerEmail"></input>
                        </div>
                        <div class="checkout_remark_input_div">
                            <input type="text" autocomplete="off" class="checkout_remark_input" :placeholder="label['checkout_order_customer_confirm_email_text']" v-model="customerInfo.orderCustomerConfirmEmail"></input>
                        </div>
                        <div class="checkout_remark_input_div">
                            <select class="checkout_remark_input select" v-model="customerInfo.orderCustomerPhone_countryCode">
                                <option v-for="(c, index) in $root.countryCodeList" :value="c">
                                    +{{c}}
                                </option>
                            </select>
                            <input type="text" autocomplete="off" class="checkout_remark_input selectinput" :placeholder="label['checkout_order_customer_phone_no_text']" v-model="customerInfo.orderCustomerPhone"></input>
                        </div>
                    </div>


                    <div class="checkout_staff_customer_info_area" v-if="cart.member == null && ($root.CheckOrderOrderTypeIdx(cart) == 2 || $root.CheckOrderOrderTypeIdx(cart) == 3)">
                        <div class="checkout_staff_customer_info_area_header_div">{{label['checkout_order_customer_info_header']}}</div>
                        <div class="checkout_remark_input_div">
                            <input type="text" autocomplete="off" class="checkout_remark_input" :placeholder="label['checkout_order_guest_mode_customer_name_text']" v-model="guestModeTypeTwo.orderName"></input>
                        </div>
                        <div class="checkout_remark_input_div">
                            <input type="text" autocomplete="off" class="checkout_remark_input" :placeholder="label['checkout_order_guest_mode_customer_email_text']" v-model="guestModeTypeTwo.orderEmail"></input>
                        </div>
                        <div class="checkout_remark_input_div">
                            <input type="text" autocomplete="off" class="checkout_remark_input" :placeholder="label['checkout_order_guest_mode_customer_confirm_email_text']" v-model="guestModeTypeTwo.orderConfirmEmail"></input>
                        </div>
                        <div class="checkout_remark_input_div">
                            <select class="checkout_remark_input select" v-model="guestModeTypeTwo.orderPhone_countryCode">
                                <option v-for="(c, index) in $root.countryCodeList" :value="c">
                                    +{{c}}
                                </option>
                            </select>
                            <input type="text" autocomplete="off" class="checkout_remark_input selectinput" :placeholder="label['checkout_order_guest_mode_customer_phone_no_text']" v-model="guestModeTypeTwo.orderPhone"></input>
                        </div>
                    </div>

                </div>

                <div class="checkout_tnc_area">

                    <div class="tnc_div" :class="{selected : isTickCheckoutTNC}">
                        <div class="tnc_tick" @click="tickCheckoutTNC()"></div>
                        <div class="tnc_message">
                            <!--<span class="tnc_message_a" v-html="label['checkout_text_tnc_message_a']"></span>
                            <span class="tnc_message_b" v-html="label['checkout_text_tnc_message_b']" @click="openCheckoutTNC()"></span>
                            <span class="tnc_message_c" v-html="label['checkout_text_tnc_message_c']"></span>-->
                                <!--
                            <span class="tnc_message_a" v-html="label['checkout_text_tnc_message_a']"></span>
                            <a :href="label['checkout_text_tnc_message_b_1_link']" class="tnc_message_b" v-html="label['checkout_text_tnc_message_b_1']" target="_blank">
                            </a>
                            <span class="tnc_message_c" v-html="label['checkout_text_tnc_message_b_and']"></span>
                            <a :href="label['checkout_text_tnc_message_b_2_link']" class="tnc_message_b" v-html="label['checkout_text_tnc_message_b_2']" target="_blank">
                            </a>
                            <span class="tnc_message_c" v-html="label['checkout_text_tnc_message_c']"></span>
                            -->
                            <span class="tnc_message_a" v-html="label['checkout_text_tnc_message_a']"></span>
                            <span @click="openCheckoutTNC()" class="tnc_message_b" v-html="label['checkout_text_tnc_message_b_1']">
                            </span>
                            <span class="tnc_message_c" v-html="label['checkout_text_tnc_message_b_and']"></span>
                            <span @click="openCheckoutTNC2()" class="tnc_message_b" v-html="label['checkout_text_tnc_message_b_2']">
                            </span>
                            <span class="tnc_message_c" v-html="label['checkout_text_tnc_message_c']"></span>
                        </div>
                    </div>

                    <div class="tnc_div" :class="{selected : isTickSavePreferShop}" v-if="CheckCanTickSavePreferShop()">
                        <div class="tnc_tick cursor_pointer" @click="TickSavePreferShop()"></div>
                        <div class="tnc_message cursor_pointer"><span class="tnc_message_a" @click="TickSavePreferShop()">{{label['save_prefer_shop_confirm_message']}}</span></div>
                    </div>

                    <div class="tnc_bottom_msg_div">
                        {{label['checkout_text_bottom_remind_message']}}
                    </div>

                </div><!-- checkout_tnc_area end -->

                <div class="checkout_checkout_btn_area">
                    <div class="checkout_btn_div" :class="{active : checkCanSubmitReturn(false)}" @click="payCb()">
                        <div class="checkout_btn_text">{{label['checkout_order_preview_now_btn_text']}}</div>
                        <div class="checkout_btn_text display_responsive">．</div>
                        <div class="checkout_btn_amount"><money :price="cart.amount" /></div>
                    </div>
                </div>
                <!-- checkout_checkout_btn_area -->

            </div>

        </div>
        <!-- checkout div end -->

        <!-- preview div start -->
        <div class="confirmation" style="width:100%;" v-if="!isCheckoutPage && order.order != null">

            <div class="checkout_back_area display_desktop">
                <div class="back_btn_div" @click="$root.goBack()">
                    <div class="back_btn"></div>
                    <div class="back_text"></div>
                </div>
            </div>

            <div class="confirmation_area">
                <div class="confirmation_div">

                    <div class="confirmation_div_title">
                        {{label["checkout_preview_page_title_text"]}}
                    </div>

                    <div class="confirmation_inner_div">

                        <div class="order_details_area_div">
                            <div class="order_details_area_div_1">

                                <div class="order_data_area">
                                    <div class="order_data_row order_type full" v-if="$root.CheckOrderOrderTypeIdx(order.order) == 1">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">
                                                <div class="order_data_title" v-if="order.order.orderMode != 'shopping'">{{label['order_history_order_details_order_type_text']}}</div>
                                                <div class="order_data_title" v-if="order.order.orderMode == 'shopping'">{{label['order_history_order_details_order_type_shopping_text']}}</div>
                                                <div class="order_data_content_a">{{$root.GetOrderModePickupTypeLabel(1,order.order.orderMode)}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="order_data_row order_type full" v-if="$root.CheckOrderOrderTypeIdx(order.order) == 2">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">
                                                <div class="order_data_title" v-if="order.order.orderMode != 'shopping'">{{label['order_history_order_details_order_type_text']}}</div>
                                                <div class="order_data_title" v-if="order.order.orderMode == 'shopping'">{{label['order_history_order_details_order_type_shopping_text']}}</div>
                                                <div class="order_data_content_a">{{$root.GetOrderModePickupTypeLabel(2,order.order.orderMode)}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="order_data_row order_type full" v-if="$root.CheckOrderOrderTypeIdx(order.order) == 3">
                                        <!-- only shopping have orderType 3 -->
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">
                                                <div class="order_data_title">{{label['order_history_order_details_order_type_shopping_text']}}</div>
                                                <div class="order_data_content_a">{{$root.GetOrderModePickupTypeLabel(3,order.order.orderMode)}}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="order_data_row delivery_date full">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">
                                                <div class="order_data_title" v-if="order.order.orderMode != 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 1">{{label['conformation_success_ready_datetime_text_delivery']}}</div>
                                                <div class="order_data_title" v-if="order.order.orderMode != 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 2">{{label['conformation_success_ready_datetime_text_pickup']}}</div>
                                                <div class="order_data_title" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 1">{{label['conformation_success_ready_datetime_shopping_text_delivery']}}</div>
                                                <div class="order_data_title" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 2">{{label['conformation_success_ready_datetime_shopping_text_pickup']}}</div>
                                                <div class="order_data_title" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 3">{{label['conformation_success_ready_datetime_shopping_text_pickup']}}</div>

                                                <div class="order_data_content_a" v-if="order.order.orderMode != 'shopping'" v-html="$root.displayOrderDateTime(order.order.readyTime, true)"></div>
                                                <!--<div class="order_data_content_a" v-if="order.order.orderMode == 'shopping'" v-html="$root.displayOrderDateTime(order.order.readyTime, true, false)"></div>-->
                                                <div class="order_data_content_a" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(cart) == 2" v-html="label['checkout_orderType_pickup_time_text']"></div>
                                                <div class="order_data_content_a" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(cart) == 3" v-html="label['checkout_orderType_pickupShop_time_text']"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="order_data_row username">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">
                                                <div class="order_data_title">{{label['member_profile_member_name_text']}}</div>
                                                <div class="order_data_content_a">{{order.order.name}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="order_data_row phone">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">
                                                <div class="order_data_title">{{label['member_profile_member_tel_text']}}</div>
                                                <div class="order_data_content_a">+{{order.order.phone_countryCode}}-{{order.order.phone}}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="order_data_row shop full" v-if="order.order.orderMode != 'shopping'">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">
                                                <div class="order_data_title">{{label['conformation_success_order_shop_text']}}</div>
                                                <div class="order_data_content_b">{{displayShop['name'+getItemSubfix()]}}</div>
                                                <div class="order_data_content_c">{{displayShop['address'+getItemSubfix()]}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="order_data_row order_type full" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 2">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">
                                                <div class="order_data_title">{{label['order_mode_pickup_type_pickup_text_'+order.order.orderMode]}}</div>
                                                <div class="order_data_content_c" v-html="$root.ContentNewLineHtmlReplace(order.order['address_full_'+getItemSubfix()])"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="order_data_row order_type full" v-if="order.order.orderMode == 'shopping' && $root.CheckOrderOrderTypeIdx(order.order) == 3">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">
                                                <div class="order_data_title">{{label['conformation_success_order_shop_text']}}</div>
                                                <div class="order_data_content_b">{{order.order.pickupShop['name'+getItemSubfix()]}}</div>
                                                <div class="order_data_content_c">{{order.order.pickupShop['address'+getItemSubfix()]}}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="order_data_row address full" v-if="$root.CheckOrderOrderTypeIdx(order.order) == 1">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">
                                                <div class="order_data_title" v-if="order.order.orderMode != 'shopping'">{{label['conformation_success_delivery_address_header_text']}}</div>
                                                <div class="order_data_title" v-if="order.order.orderMode == 'shopping'">{{label['conformation_success_delivery_address_header_text_shopping']}}</div>
                                                <div class="order_data_content_c" v-html="$root.ContentNewLineHtmlReplace(order.order['address_full_'+getItemSubfix()])"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="order_data_row coupon full" v-if="order.order.coupons.length > 0">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">
                                                <div class="order_data_title">{{label['checkout_order_use_coupon_header_text']}}</div>
                                                <div class="order_data_content_a"
                                                     v-for="(coup, index) in order.order.coupons">{{coup.couponName}}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="order_data_row coupon full" v-if="order.order.couponCode != null && order.order.couponCode != ''">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">
                                                <div class="order_data_title">{{label['checkout_order_use_discount_code_header_text']}}</div>
                                                <div class="order_data_content_a">{{order.order.couponCode}}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="order_data_row DeliveryMessage full" v-if="$root.displayOrderDeliveryMessage(order) != ''">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">
                                                <div class="order_data_title">{{label['checkout_delivery_remark_text']}}</div>
                                                <div class="order_data_content_a" v-html="$root.displayOrderDeliveryMessage(order)"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <!--<div class="order_data_row OrderRemarks full" v-if="$root.displayOrderRemarksPreview(order) != ''">
                                        <div class="order_data_tag_inner_div">
                                            <div class="tag_icon"></div>
                                            <div class="tag_content">
                                                <div class="order_data_title">{{label['checkout_order_remark_text']}}</div>
                                                <div class="order_data_content_a" v-html="$root.displayOrderRemarksPreview(order)"></div>
                                            </div>
                                        </div>
                                    </div>-->

                                </div>

                            </div>

                            <div class="order_details_area_div_2">

                                <div class="order_items_area">
                                    <div class="order_items_list_header">{{label['conformation_success_order_data_header_text']}}</div>
                                    <div class="order_items_list_area">

                                        <CartListItem v-bind:cart="order.order" v-bind:can_update="false">
                                        </CartListItem>

                                    </div>
                                </div>

                                <div class="order_payment_area">
                                    <div class="order_payment_area_header">{{label['checkout_payment_method_header_text']}}</div>
                                    <div class="order_payment_area_content">
                                        <div class="order_payment_text">
                                            <div class="text_div">{{ getPayMethodObj($root.tempPaymentMethod)["name" + getItemSubfix()] }}</div>
                                            <div class="icon_div master_card" v-if="getPayMethodObj($root.tempPaymentMethod)['code'] == 'cybersource'"><img src="/files/images/main/payment_ico_master.png" align="absmiddle" /></div>
                                            <div class="icon_div visa_card" v-if="getPayMethodObj($root.tempPaymentMethod)['code'] == 'cybersource'"><img src="/files/images/main/payment_ico_visa_secure.png" align="absmiddle" /></div>
                                        </div>
                                        <div class="order_payment_icon" :style="{'background-image':'url(\''+getPayMethodObj($root.tempPaymentMethod)['image']+'\')'}"></div>
                                    </div>
                                </div>

                                <div class="order_amount_area">

                                    <div class="order_amount_row">
                                        <div class="price_text">{{label['amount_label']}}</div>
                                        <div class="price_amount">
                                            <!--<money :price="$root.sumItemListPrice(order.order.items)" />-->
                                            <money :price="order.order.amountWithoutDiscount" />
                                        </div>
                                    </div>

                                    <div class="order_amount_row isAlert" v-if="order.order.minCharge > 0">
                                        <div class="price_text">{{label['cart_fit_minCharge_text']}}</div>
                                        <div class="price_amount">
                                            <money :price="order.order.minCharge" />
                                        </div>
                                    </div>

                                    <div class="order_amount_row" v-if="order.order.packingCharge > 0">
                                        <div class="price_text">{{label['cart_packingCharge_text']}}</div>
                                        <div class="price_amount">
                                            <money :price="order.order.packingCharge" />
                                        </div>
                                    </div>

                                    <!-- load discount item start -->
                                    <div class="order_amount_row"
                                         v-for="(discount, index) in order.order.discounts.filter(x => !x.isHide)"
                                         :key="'d'+index">
                                        <div class="price_text">{{discount['name'+getItemSubfix()]}}</div>
                                        <div class="price_amount">
                                            -<money :price="discount.price" />
                                        </div>
                                    </div>
                                    <!-- load discount item end -->

                                    <div class="order_amount_row" v-if="order.order.deliveryCharge > 0">
                                        <div class="price_text">{{label['cart_deliveryCharge_text']}}</div>
                                        <div class="price_amount">
                                            <money :price="order.order.deliveryCharge" />
                                        </div>
                                    </div>

                                    <div class="order_amount_row" v-if="order.order.usedECash > 0">
                                        <div class="price_text">{{label['checkout_order_use_ecash_text_used_ecash']}}</div>
                                        <div class="price_amount">
                                            -<money :price="order.order.usedECash" />
                                        </div>
                                    </div>

                                    <div class="order_amount_row ">
                                        <div class="price_text">{{label['total_amount_need_pay_label']}}</div>
                                        <div class="price_amount">
                                            <money :price="order.order.amount" />
                                        </div>
                                    </div>

                                </div>

                                <div class="order_amount_area" v-if="order != undefined && order.order.payments != undefined && order.order.payments.length > 0">

                                    <div class="order_amount_row">
                                        <div class="price_header">{{label['checkout_payment_method_header_text']}}</div>
                                        <div class="price_text aligh_left">{{order.order.payments[0]['name'+getItemSubfix()]}}</div>
                                        <div class="price_amount">
                                            <money :price="order.order.payments[0].amount" />
                                        </div>
                                    </div>

                                </div>

                                <div class="order_amount_area no_border no_top">

                                    <div class="order_amount_row final_amount">
                                        <div class="price_text">{{label['total_amount_label']}}</div>
                                        <div class="price_amount">
                                            <money :price="order.order.amount" />
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div class="page_bottom_btn_div">
                            <div class="bottom_btn" :class="{active : checkCanSubmitReturn(false)}" @click="payCb()">{{label['checkout_order_now_btn_text']}}</div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- preview div end -->


        <modal v-if="showQrcodePanel" @close="cancelQRPayment()">
            <div slot="body">
                <div class="qrccode_header">{{QRCodeHeader}}</div>
                <div ref="qrcode" style="display: flex; justify-content: center"></div>
            </div>
            <div slot="footer" class="text-center">
                <button class="close_btn" @click="cancelQRPayment()">
                    {{ label["qrcode_cancel_label"] }}
                </button>
            </div>
        </modal>

        <modal2 v-if="memberNextLevelAmount.show" @close="memberNextLevelAmount.show = false">
            <div slot="body" v-html="memberNextLevelAmount.message"></div>
            <div slot="footer" class="text-center">
                <button class="close_btn" @click="memberNextLevelAmount.show = false">
                    {{ label["alert_close_btn"] }}
                </button>
            </div>
        </modal2>

        <!-- payment_select_layer_area start -->
        <transition name="slide-up">
            <div class="payment_select_layer" v-if="showPayMethodPanelLayer" :style="{'height':$root.full_screen_height.height_fix}">

                <div class="payment_select_layer_div">

                    <div class="payment_select_layer_header_area">
                        <div class="payment_select_layer_close_btn" @click="closePayMethodPanelLayer()"></div>
                    </div>
                    <!-- payment_select_layer_header_area end -->

                    <div class="payment_select_layer_body_area">

                        <div class="payment_select_layer_info_area">
                            <div class="payment_select_layer_info_header">{{label['checkout_payment_method_header_text']}}</div>
                        </div>
                        <!-- payment_select_layer_info_area end -->

                        <div class="payment_select_layer_display_area">

                            <div class="payment_select_layer_list_area">
                                <!--
                                <div class="payment_select_layer_list_row"
                                     v-for="(item, index) in payMethodList"
                                     :key="index"
                                     :class="{isTop: (index == 0 || index == 1), TopLeft: index == 0, TopRight: index == 1}"
                                     >

                                    <div v-if="(index == 0 || index == 1)" class="payment_select_layer_list_div" :class="{isselect: (payMethodTemp != undefined &&item.code == payMethodTemp.code)}" @click="setPayMethodTemp(item)">
                                        <div class="payment_select_layer_image_only_area">
                                            <img :src="item.image" align="absmiddle" />
                                        </div>
                                    </div>

                                    <div v-if="index > 1" class="payment_select_layer_list_div" :class="{isselect: (payMethodTemp != undefined &&item.code == payMethodTemp.code)}" @click="setPayMethodTemp(item)">
                                        <div class="payment_select_layer_text_area">
                                            <div class="payment_select_layer_text_div">
                                                <div class="text_div">{{ item["name" + getItemSubfix()] }}</div>
                                                <div class="icon_div master_card" v-if="item.code == 'cybersource'"><img src="/files/images/main/payment_ico_master.png" align="absmiddle" /></div>
                                                <div class="icon_div visa_card" v-if="item.code == 'cybersource'"><img src="/files/images/main/payment_ico_visa_secure.png" align="absmiddle" /></div>
                                            </div>
                                            <div class="payment_select_layer_icon_div" :style="{'background-image':'url(\''+item.image+'\')'}"></div>
                                        </div>
                                    </div>

                                </div>
                                -->
                                <div class="payment_select_layer_list_row"
                                     v-for="(item, index) in payMethodList"
                                     :key="index">
                                    <div class="payment_select_layer_list_div" :class="{isselect: (payMethodTemp != undefined &&item.code == payMethodTemp.code), disable : !checkPayMethodInCoupon(item)}" @click="setPayMethodTemp(item)">
                                        <div class="payment_select_layer_text_area">
                                            <div class="payment_select_layer_text_div">
                                                <div class="text_div">{{ item["name" + getItemSubfix()] }}</div>
                                                <div class="icon_div master_card" v-if="item.code == 'cybersource'"><img src="/files/images/main/payment_ico_master.png" align="absmiddle" /></div>
                                                <div class="icon_div visa_card" v-if="item.code == 'cybersource'"><img src="/files/images/main/payment_ico_visa_secure.png" align="absmiddle" /></div>
                                            </div>
                                            <div class="payment_select_layer_icon_div" :style="{'background-image':'url(\''+item.image+'\')'}"></div>
                                        </div>
                                    </div>
                                    <!-- payment_select_layer_list_div -->

                                </div>

                            </div>
                            <!-- payment_select_layer_list_area end -->

                        </div>
                        <!-- payment_select_layer_display_area -->

                    </div>

                    <div class="payment_select_layer_confirm_area">
                        <div class="payment_select_layer_confirm_btn" @click="setPayMethodLayer()">{{label['common_text_confirm']}}</div>
                    </div>
                    <!-- payment_select_layer_confirm_area end -->

                </div>
            </div>
        </transition>
        <!-- payment_select_layer_area end -->

        <!-- checkout select coupon layer start -->
        <transition name="slide-up">
            <div class="checkout_select_coupon_layer" v-if="CheckoutSelectCouponLayerObj.showCheckoutSelectCouponLayer" :style="{'height':$root.full_screen_height.height_fix}">
                <div class="checkout_select_coupon_layer_background" @click="CloseOrderCouponEditLayer()" :style="{'height':$root.full_screen_height.height_fix}"></div>

                <div class="checkout_select_coupon_layer_div">
                    <div class="checkout_select_coupon_layer_inner_div">
                        <div class="checkout_select_coupon_layer_header_area">
                            <div class="checkout_select_coupon_layer_close_btn" @click="CloseOrderCouponEditLayer()"></div>
                        </div>
                        <div class="checkout_select_coupon_layer_info_area">
                            <div class="header_div">
                                {{label['checkout_order_use_coupon_layer_header_text']}}
                            </div>
                            <div class="checkout_select_coupon_layer_body_area">
                                <div class="checkout_select_coupon_layer_display_area" v-if="CheckoutSelectCouponLayerObj.display_coupon.length > 0">

                                    <div class="coupon_select_area">

                                        <div class="coupon_select_option_div nocursor"
                                             v-for="(coup, index) in CheckoutSelectCouponLayerObj.display_coupon"
                                             :key="index"
                                             :class="{isSelect : CheckCouponLayerIsDisplaySelect(coup), notAvailable : !CheckCouponLayerIsAvailable(coup)}">
                                            <div class="total_coupon_box_div">
                                                <div class="total_coupon_box_text">x{{coup.couponList.length}}</div>
                                            </div>
                                            <div class="coupon_select_option_info_div">
                                                <div class="coupon_select_option_title_div">{{coup['couponName' + getItemSubfix()]}}</div>
                                                <div class="coupon_select_option_date_div">{{label['checkout_coupon_text_coupon_expiry_date']}}: {{$root.writeDisplayDateFormat(coup['effectiveStartDate'])}} - {{$root.writeDisplayDateFormat(coup['effectiveEndDate'])}}</div>
                                                <!--<div class="coupon_select_option_remark_div" v-html="coup['couponRemark']" v-if="coup['couponRemark'] != ''"></div>-->

                                                <div class="tnc_qty_div display_desktop isflex">
                                                    <!--<div class="tnc_div">
                                                    <div class="tnc_div_text" @click="openCouponTNC(coup)">{{label['checkout_coupon_text_tnc']}}</div>
                                                </div>-->
                                                    <div class="tnc_div">
                                                        <div class="tnc_div_text" @click="openCouponRemark(coup)">{{label['checkout_coupon_text_tnc']}}</div>
                                                    </div>
                                                    <div class="qty_div">
                                                        <div class="tag_qty_select">
                                                            <div class="tag_icon min" :class="{'disable' : coup.selectQty <= 0}" @click="couponSelectTagQtyAdd(coup,'min')"></div>
                                                            <div class="tag_qty">{{coup.selectQty}}</div>
                                                            <div class="tag_icon plus" :class="{'disable' : (coup.selectQty >= coup.maxUse || coup.selectQty >= coup.couponList.length)}" @click="couponSelectTagQtyAdd(coup,'add')"></div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="coupon_select_option_img_div" v-if="coup['imageUrl'] != ''">
                                                <div class="coupon_select_option_img">
                                                    <img :src="coup['imageUrl']" align="absmiddle" />
                                                </div>
                                            </div>

                                            <div class="tnc_qty_div display_responsive isflex">
                                                <!--<div class="tnc_div">
                                                <div class="tnc_div_text" @click="openCouponTNC(coup)">{{label['checkout_coupon_text_tnc']}}</div>
                                            </div>-->
                                                <div class="tnc_div">
                                                    <div class="tnc_div_text" @click="openCouponRemark(coup)">{{label['checkout_coupon_text_tnc']}}</div>
                                                </div>
                                                <div class="qty_div">
                                                    <div class="tag_qty_select">
                                                        <div class="tag_icon min" :class="{'disable' : coup.selectQty <= 0}" @click="couponSelectTagQtyAdd(coup,'min')"></div>
                                                        <div class="tag_qty">{{coup.selectQty}}</div>
                                                        <div class="tag_icon plus" :class="{'disable' : (coup.selectQty >= coup.maxUse || coup.selectQty >= coup.couponList.length)}" @click="couponSelectTagQtyAdd(coup,'add')"></div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                </div>
                                <div class="checkout_select_coupon_layer_display_area" v-if="CheckoutSelectCouponLayerObj.display_coupon.length <= 0">
                                    {{label['checkout_order_use_coupon_layer_no_coupon']}}
                                </div>
                            </div>
                        </div>
                        <div class="checkout_select_coupon_layer_confirm_area">
                            <div class="checkout_select_coupon_layer_confirm_btn" @click="OrderCouponLayerEditConfirm()">{{label['checkout_order_use_coupon_layer_confirm_text']}}</div>
                        </div>
                    </div>

                </div>
            </div>
        </transition>
        <!-- checkout select coupon layer end -->

        <!-- guestMode address profile start -->
        <transition name="slide-up">
            <div class="modify_address_area" v-if="guestMode.isOpen" :style="{'height':$root.full_screen_height.height_fix}">

                <div class="modify_address_div">

                    <div class="modify_address_header_area">
                        <div class="modify_address_close_btn" @click="guestModeClose()"></div>
                    </div>
                    <!-- modify_address_header_area end -->

                    <div class="modify_address_body_area full_height">

                        <div class="modify_address_info_area">
                            <div class="modify_address_info_header">{{label['checkout_order_info_select_address_header_text']}}</div>
                        </div>
                        <!-- modify_address_info_area end -->

                        <div class="modify_address_form_area all_padding">
                            <div class="modify_address_form_div">

                                <div class="address_form_full_address_div" :key="guestMode.guestMode_address_isUpdate">{{guestMode.address['address_full_'+info.lang]}}</div>

                                <div class="address_form_div">

                                    <div class="map_address_area address_input_div">
                                        <div class="map_location_icon" @click="$root.SearchAddressPositionLL('guestMode_address_map_location_input','guestMode_add')"></div>
                                        <div class="map_location_input_div input_area" :class="{inSearch : $root.isSearchAddressFocus}">
                                            <input autocomplete="off" type="text" class="map_location_input" id="guestMode_address_map_location_input" value="" :placeholder="label['search_address_building_text']" @keyup="$root.SearchAddressText($event,'add_modify')" @focus="$root.SearchAddressFocus($event,'add_modify')" @blur="$root.SearchAddressBlur($event,'add_modify')" />
                                        </div>
                                        <div class="map_location_cancel_icon_div" v-if="$root.isSearchAddressFocus">
                                            <div class="map_location_cancel_icon" @click="$root.SearchAddressCancel()"></div>
                                        </div>
                                        <div class="map_location_cancel_icon_div search_icon" v-if="$root.isSearchAddressFocus">
                                            <div class="map_location_cancel_icon" @click="$root.SearchAddressText($event,'guestMode_add')"></div>
                                        </div>
                                    </div>

                                    <div class="flat_floor_area">
                                        <div class="block_div">
                                            <input autocomplete="off" type="text" class="address_form_input" id="guest_mode_address_map_location_block_input" v-model="guestMode.address.block" maxlength="10" :placeholder="label['modify_address_block_text']" @blur="guestModeAddressUpdateFullAddress()" />
                                        </div>
                                        <div class="floor_div">
                                            <input autocomplete="off" type="text" class="address_form_input" id="guest_mode_address_map_location_floor_input" v-model="guestMode.address.floor" maxlength="10" :placeholder="label['modify_address_floor_text']" @blur="guestModeAddressUpdateFullAddress()" />
                                        </div>
                                        <div class="flat_div">
                                            <input autocomplete="off" type="text" class="address_form_input" id="guest_mode_address_map_location_flat_input" v-model="guestMode.address.flat" maxlength="10" :placeholder="label['modify_address_flat_text']" @blur="guestModeAddressUpdateFullAddress()" />
                                        </div>
                                    </div>

                                    <div class="receiver_area">
                                        <div class="receiver_header_area">{{label['modify_address_header']}}</div>

                                        <div class="receiver_input_area">
                                            <div class="receiver_name_div">
                                                <input autocomplete="off" type="text" class="address_form_input" id="guest_mode_input_orderCustomerName" v-model="guestMode.contact_info.name" maxlength="50" :placeholder="label['checkout_order_guest_mode_customer_name_text']" />
                                            </div>

                                            <div class="receiver_name_div">
                                                <input autocomplete="off" type="text" class="address_form_input" id="guest_mode_input_orderCustomerEmail" v-model="guestMode.contact_info.email" maxlength="50" :placeholder="label['checkout_order_guest_mode_customer_email_text']" />
                                            </div>
                                            <div class="receiver_tel_div">
                                                <select class="address_form_input select" id="guest_mode_input_orderCustomerPhone_countryCode" v-model="guestMode.contact_info.tel_countryCode">
                                                    <option v-for="(c, index) in $root.countryCodeList" :value="c">
                                                        +{{c}}
                                                    </option>
                                                </select>
                                                <input autocomplete="off" type="text" class="address_form_input selectinput" id="guest_mode_input_orderCustomerPhone" v-model="guestMode.contact_info.tel" maxlength="20" :placeholder="label['checkout_order_guest_mode_customer_phone_no_text']" />
                                            </div>
                                            <!--<div class="receiver_subtel_div">
                                                <input autocomplete="off" type="text" class="address_form_input" id="guest_mode_input_orderCustomerPhone2" v-model="guestMode.contact_info.tel2" maxlength="20" :placeholder="label['checkout_order_guest_mode_customer_phone_no_2_text']" />
                                            </div>-->
                                        </div>

                                    </div>

                                </div>

                                <div class="address_form_update_btn_div">
                                    <div class="address_confirm_btn" :class="{active : guestModeAddressEditCheckCanSubmit(false)}" @click="guestModeAddressEditUpdate()">{{label['modify_address_complete_address_text']}}</div>
                                </div>

                            </div>
                        </div>
                        <!-- modify_address_form_area -->

                    </div>

                </div>
            </div>
        </transition>
        <!-- guestMode address profile end -->

        <!-- deliveryMethod lockerOption layer start -->
        <transition name="slide-up">
            <div class="checkout_select_coupon_layer" v-if="lockerOptionLayerObj.showLayer" :style="{'height':$root.full_screen_height.height_fix}">

                <div class="checkout_select_coupon_layer_div">
                    <div class="checkout_select_coupon_layer_inner_div">

                        <div class="checkout_select_coupon_layer_header_area">
                            <div class="checkout_select_coupon_layer_close_btn" @click="CloseDeliveryMethodLockerOptionSelectLayer()"></div>
                        </div>
                        <!-- checkout_select_coupon_layer_header_area end -->

                        <div class="checkout_select_coupon_layer_info_area">
                            <div class="header_div">
                                {{label['checkout_please_select_delivery_method_locker_option_text_header']}}
                            </div>

                            <div class="checkout_select_coupon_layer_body_area">

                                <div class="checkout_select_coupon_layer_display_area havePaddingTop">

                                    <div class="coupon_select_option_area">
                                        <div class="order_shop_select_option_select_div">
                                            <select class="" @change="$root.ChangeSelectShoppingDistrictArea($event, CheckDeliveryMethodLockerOption)">
                                                <option class="" value="">
                                                    {{label['home_shop_district_select_please_select_area_text']}}
                                                </option>
                                                <option class=""
                                                        v-for="(s, index) in $root.shoppingDistrictList"
                                                        :value="s.areaCode"
                                                        :selected="s.areaCode == lockerOptionLayerObj.selectArea">
                                                    {{ s['areaName'+getItemSubfix()] }}
                                                </option>
                                            </select>
                                        </div>

                                        <div class="order_shop_select_option_select_div">
                                            <select class="" @change="$root.ChangeSelectShopDistrictAreaDistrict($event, CheckDeliveryMethodLockerOption)">
                                                <option class="" value="">
                                                    {{label['home_shop_district_select_please_select_district_text']}}
                                                </option>
                                                <option class=""
                                                        v-for="(d, index) in $root.homeSelectShop.homeSelectShopAreaDistrictList"
                                                        :value="d.districtCode"
                                                        :selected="d.districtCode == lockerOptionLayerObj.selectDistrict">
                                                    {{ d['districtName'+getItemSubfix()] }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="coupon_select_area">

                                        <div class="coupon_select_option_div"
                                             v-for="(item, index) in lockerOptionLayerObj.lockerList"
                                             :key="index"
                                             @click="DeliveryMethodLockerOptionSelectLayerSelect(item)"
                                             :class="{isSelect : DeliveryMethodLockerOptionSelectLayerIsSelect(item)}">
                                            <div class="coupon_select_option_info_div">
                                                <div class="coupon_select_option_desc_div solidText" v-html="item['display' + getItemSubfix()]"></div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <!-- checkout_select_coupon_layer_display_area -->

                            </div>
                        </div>

                        <div class="checkout_select_coupon_layer_confirm_area">
                            <div class="checkout_select_coupon_layer_confirm_btn" @click="DeliveryMethodLockerOptionSelectLayerConfirm()">{{label['checkout_please_select_delivery_method_locker_option_text_confirm_btn']}}</div>
                        </div>
                        <!-- checkout_select_coupon_layer_confirm_area end -->

                    </div>
                </div>
            </div>
        </transition>
        <!-- deliveryMethod lockerOption layer end -->

        <!-- checkout tnc start -->
        <transition name="slide-up">
            <div class="tnc_popup_div" v-if="isOpenCheckoutTNC" :style="{'height':$root.full_screen_height.height_fix}">
                <div class="tnc_popup_div_background" @click="closeCheckoutTNC()" :style="{'height':$root.full_screen_height.height_fix}"></div>

                <div class="tnc_popup_div_layer">
                    <div class="tnc_popup_inner_div">
                        <div class="tnc_popup_top_div">
                            <div class="close_icon" @click="closeCheckoutTNC()"></div>
                        </div>
                        <div class="tnc_popup_middle_div">
                            <div class="header_div">
                                {{checkoutTNCHeader}}
                            </div>
                            <div class="body_div">
                                <div class="body_content" v-html="checkoutTNCContent"></div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </transition>
        <!-- checkout tnc end -->

        <!-- checkout changeShop layer start -->
        <transition name="slide-up">
            <div class="checkout_changeShop_layer" v-if="CheckoutChangeShopLayerObj.showCheckoutChangeShopLayer" :style="{'height':$root.full_screen_height.height_fix}">
                <div class="checkout_changeShop_layer_background" @click="CloseShopChangeLayerPanel()" :style="{'height':$root.full_screen_height.height_fix}"></div>

                <div class="checkout_changeShop_layer_div">
                    <div class="checkout_changeShop_layer_inner_div">
                        <div class="checkout_changeShop_layer_header_area">
                            <div class="checkout_changeShop_layer_close_btn" @click="CloseShopChangeLayerPanel()"></div>
                        </div>
                        <div class="checkout_changeShop_layer_info_area">
                            <div class="header_div" v-if="$root.CheckOrderOrderTypeIdx(cart) == 1">{{$root.GetOrderModePickupTypeLabel(1,cart.orderMode)}}{{label['checkout_header_information_text_ending']}}</div>
                            <div class="header_div" v-if="$root.CheckOrderOrderTypeIdx(cart) == 2">{{$root.GetOrderModePickupTypeLabel(2,cart.orderMode)}}{{label['checkout_header_information_text_ending']}}</div>
                            <div class="header_div" v-if="$root.CheckOrderOrderTypeIdx(cart) == 3">{{$root.GetOrderModePickupTypeLabel(3,cart.orderMode)}}{{label['checkout_header_information_text_ending']}}</div>

                            <div class="checkout_changeShop_layer_body_area">
                                
                                <div class="full_width_area padding_width no_border">
                                    <div class="full_width_area">
                                        <div class="order_shop_district_select_div">
                                            <div class="order_shop_select_title">{{label['home_shop_district_select_title_text']}}</div>
                                            <div class="order_shop_select_option_div">
                                                <div class="order_shop_select_option">

                                                    <div class="order_shop_select_option_select_div left_div">
                                                        <select class="" @change="ShopChangeLayerShopDistrictArea($event)">
                                                            <option class="" value="">
                                                                {{label['home_shop_district_select_please_select_area_text']}}
                                                            </option>
                                                            <option class=""
                                                                    v-for="(s, index) in CheckoutChangeShopLayerObj.area_list"
                                                                    :value="s.areaCode"
                                                                    :selected="s.areaCode == CheckoutChangeShopLayerObj.select_area">
                                                                {{ s['areaName'+getItemSubfix()] }}
                                                            </option>
                                                        </select>
                                                    </div>

                                                    <div class="order_shop_select_option_select_div right_div">
                                                        <select class="" v-if="!info.order_setting.pickupShopAreaFilter" @change="ShopChangeLayerShopDistrictAreaDistrict($event)">
                                                            <option class="" value="">
                                                                {{label['home_shop_district_select_please_select_district_text']}}
                                                            </option>
                                                            <option class=""
                                                                    v-for="(d, index) in CheckoutChangeShopLayerObj.district_list"
                                                                    :value="d.districtCode"
                                                                    :selected="d.districtCode == CheckoutChangeShopLayerObj.select_district">
                                                                {{ d['districtName'+getItemSubfix()] }}
                                                            </option>
                                                        </select>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="full_width_area no_border">                                    
                                        <div class="home_shop_select_div" v-if="CheckoutChangeShopLayerObj.shop_list.length > 0">

                                            <div class="home_shop_select_row" :class="{inactive: !s.isOpen, isSelect: s.shopCode_global == CheckoutChangeShopLayerObj.select_shop }" v-for="(s, index) in CheckoutChangeShopLayerObj.shop_list" @click="ShopChangeLayerShopSelect(s)">
                                                <div class="shop_info_div">
                                                    <div class="shop_name">
                                                        <div class="shop_distance" v-if="s.distance > -1">
                                                            {{s.distance + ' ' + label['shop_list_km_label']}}
                                                        </div>
                                                        {{ s["name" + getItemSubfix()] }}
                                                    </div>
                                                    <div class="shop_address">
                                                        {{ s["address" + getItemSubfix()] }}
                                                    </div>
                                                </div>
                                                <div class="arrow_div"></div>
                                            </div>

                                        </div>

                                        <div class="home_shop_select_div" v-if="CheckoutChangeShopLayerObj.shop_list.length <= 0">

                                            <div class="home_shop_select_row">
                                                <div class="shop_info_div full">
                                                    <div class="shop_name">
                                                        {{label["shop_list_shop_not_found"]}}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="checkout_changeShop_layer_confirm_area">
                            <div class="checkout_changeShop_layer_confirm_btn" @click="ShopChangeLayerEditConfirm()">{{label['checkout_order_use_coupon_layer_confirm_text']}}</div>
                        </div>
                    </div>

                </div>
            </div>
        </transition>
        <!-- checkout changeShop layer end -->

    </div>
</template>
 
<script>
    import Modal from "../components/Modal.vue";
    import Modal2 from "../components/Modal2.vue";
    import CartListItem from "../components/CartListItem.vue";

    export default {
        data() {
            return {
                CheckoutListUpdate: 0,

                isCheckoutPage: true,
                isCheckoutPageCount: 0,                
                isOpenCheckoutTNC: false,
                checkoutTNCHeader: "",
                checkoutTNCContent: "",
                isTNCPageBodyFix: true,
                isTickCheckoutTNC: false,
                isTickSavePreferShop: false,
                order: {
                    order: null
                    },

                showPayMethodPanel: false,
                showPayMethodPanelLayer: false,
                //payMethod: undefined,
                payMethodTemp: undefined,
                payMethodList: [
                    {
                        code: "-1",
                        name1: "",
                        name2: "",
                        name3: "",
                        image: ""
                    }
                ],
                payMethodList_method: null,

                showQuoteTimePanel: false,
                quoteTime: 1,
                quoteTimeList: [],

                checkPaymentTimer: -1,

                showQrcodePanel: false,
                QRCodeHeader: "",
                canSubmitOrder: false,

                showDeliveryMessagePanel: false,
                DeliveryMessageList: [
                ],

                showDeliveryMethodPanel: false,
                DeliveryMethodListRaw: null,
                DeliveryMethodList: [
                ],

                orderRemark: "",
                customerInfo: {
                    orderCustomerName: "",
                    orderCustomerEmail: "",
                    orderCustomerConfirmEmail: "",
                    orderCustomerPhone: "",
                    orderCustomerPhone_countryCode: "852"
                },
                guestModeTypeTwo: {
                    orderName: "",                    
                    orderEmail: "",
                    orderConfirmEmail: "",
                    orderPhone: "",
                    orderPhone_countryCode: "852"
                },
                guestMode: {
                    isOpen: false,
                    guestMode_address_isUpdate: 0,
                    address: null,
                    contact_info: null
                },
                
                displayShop: null,
                
                UseECashObj: {
                    inUse: false,
                    eCashUse: "",
                    isError: false
                },
                UseDiscountCodeObj: {
                    inUse: false,
                    codeUse: "",
                    isError: false
                },
                CheckoutSelectCouponLayerObj: {
                    showCheckoutSelectCouponLayer: false,
                    coupon_list: [],
                    select_coupon: [],
                    use_coupon: [],
                    display_coupon: []
                },
                CheckoutChangeShopLayerObj: {
                    showCheckoutChangeShopLayer: false,
                    area_list: [],
                    district_list: [],
                    shop_list: [],
                    shop_list_all: [],
                    select_area: "",
                    select_district: "",
                    select_shop: "",
                    current_area: "",
                    current_district: "",
                    current_shop: ""
                },

                lockerOptionLayerObj: {
                    showLayer: false,
                    lockerOption:'',
                    lockerList: [],
                    selectLockerTemp: null,
                    selectLocker: null,
                    selectArea: "",
                    selectDistrict: ""
                },

                memberNextLevelAmount: {
                    show: false,
                    message: ""
                }
            };
        },
        computed: {
            info() {
                return this.$root.info;
            },
            label() {
                return this.$root.getLabel();
            },
            cart() {
                return this.$root.cart;
            },
            EnableReceiveNews() {
                return this.info.receiveNews || false;
            },
            isStaffAccount() {
                if (this.cart.member != null) {
                    return this.info.staffAccount.indexOf(this.cart.member.memberCode) >= 0
                } else {
                    return false;
                }
            }
        },
        components: { Modal, Modal2, CartListItem },
        beforeCreate() {
            // check history can forward
            try {
                window.history.forward();
            } catch (e) {}
        },
        created() {          
            var app = this;

            // prevent cannot scroll when loading the page            
            this.$root.setBodyOverflow(false);
            this.info.itemMenuDetailsOpen = false;
            
            this.info.loading = false;
            this.$root.getCurrentPathName();

            this.isCheckoutPage = this.$root.info.currentPathName == "/preview" ? false : true;
            if (!this.isCheckoutPage && this.order.order == null) {
                this.$router.replace("/checkout");
            }

            //this.payMethod = this.payMethodList[0]; 
            this.$root.tempPaymentMethod = this.payMethodList[0];


            // check if guest mode or not
            if (!this.info.allowGuestMode && this.cart.member == null) {
                this.$root.page_after_login = "/checkout";
                this.$router.replace("/guestlogin");
            }


            // check have brand and shop or not
            this.$root.initSelectBrand();

            // check have order or not            
            if (this.cart.shop == undefined) {
                this.$root.alert("session_timeout_label");
                this.$router.replace("/");
            }
            else {
                if (this.cart.items.length <= 0) {
                    this.$router.replace("/menu");
                } else if (this.cart.member == null) {
                    //this.$root.LoginBtnClick();
                }
                this.displayShop = this.$root.getShopInfo(this.cart.shop.shopCode);
            }

            // check order_type = 3 contains pickupShopCode
            if (this.$root.getCurrentOrderTypeSubfix == "3" && (this.cart.pickupShopCode == null || this.cart.pickupShopCode == "")) {
                //this.$router.replace("/"); // hide on 20260715 for moving the select to confirmation page 
            }

            //if (this.cart.shop != undefined && this.cart.member != null) {
            if (this.cart.shop != undefined && this.cart.items.length > 0) {
                app.info.loading = true;
                app.getPaymethodJson(null,true);
                $.when(
                    /*
                    $.get(
                        "/files/payMethod.json", // server will not loading the physical file, urlrewrite on server calling api
                        (data) => {
                            app.payMethodList = data.list;
                            if (app.payMethodList.length > 0) {
                                //app.payMethod = app.payMethodList[0];
                                //app.payMethodTemp = app.payMethodList[0];
                                //app.checkCanSubmit();
                                if (app.cart.tempPaymentMethod != null) {
                                    app.setPayMethodNormal(getPayMethodObj(app.cart.tempPaymentMethod));
                                } else {
                                    app.setPayMethodNormal(app.payMethodList[0]);
                                }
                            }
                        },
                        "JSON"
                    ),
                    */
                    $.get(
                        "/files/deliveryMessage.json",
                        (data) => {
                            app.DeliveryMessageList = data.list;
                            if (app.DeliveryMessageList.length > 0) {
                                //app.DeliveryMessage = app.DeliveryMessageList[0];
                            }
                        },
                        "JSON"
                    ),
                    $.get(
                        "/files/deliveryMethod.json",
                        (data) => {
                            app.DeliveryMethodListRaw = data;
                            app.setDeliveryMethodList(app.DeliveryMethodListRaw, app.checkoutOrderInfoEditCB);
                        },
                        "JSON"
                    )
                ).then(function () {
                    app.info.loading = false;
                });

                //console.log("this.cart", this.cart);                
                if (this.cart.remark == undefined || this.cart.remark == null) {
                    this.cart.remark = "";
                }
                // remove extra remark
                this.cartRemoveExtraRemark();
                this.orderRemark = this.cart.remark;

                if (app.cart.member != null) {
                    // open modify address if contact info is null
                    //console.log("app.info.order_temp_info", app.info.order_temp_info);
                    if (!app.checkOrderAddressContact(false)) {
                        //this.$root.modifyAddressOpen('checkout', app.label['checkout_order_info_select_address_header_text']);
                        app.$root.modifyAddressOpen('checkout', app.$root.ModifyAddressLayerHeaderText());

                        var modify_isSelect = app.$root.modify_address_list.filter(a => a.isSelect)[0];
                        app.$root.modifyAddressEditClick(modify_isSelect);
                    }
                }
                else {

                    if (this.$root.CheckOrderOrderTypeIdx(app.cart) == 2 || this.$root.CheckOrderOrderTypeIdx(app.cart) == 3) {
                        if (app.cart.name != "GUEST") {
                            app.guestModeTypeTwo.orderName = app.cart.name;
                            app.guestModeTypeTwo.orderEmail = app.cart.email;
                            app.guestModeTypeTwo.orderPhone = app.cart.phone;
                            app.guestModeTypeTwo.orderPhone_countryCode = app.cart.phone_countryCode;
                        }
                    }
                    else {
                        // open guest mode profile layer
                        if (app.info.allowGuestMode && !app.checkOrderAddressContact(false)) {
                            app.guestModeOpen();
                        }
                    }
                }
            }

            this.checkCanSubmit();

            //this.CartCheckoutECashInit();
            this.OrderCouponEditLayerInit();
            this.CartCheckoutDiscountCodeInit();  

            this.checkMinChargeAlert();
            this.checkMemberNextLevelAmountAlert();
        },
        destroyed() {
            this.$root.setGoBackAction();
            clearTimeout(this.checkPaymentTimer);
        },
        mounted() {
            this.$root.FlowArrowCheck();

            // on widow back
            var app = this;
            window.onpopstate = function (event) {
                app.goBack();
            };
        },
        watch: {
            '$route': function (to, from) {
                if (to.path === '/preview') {
                    this.isCheckoutPage = false;
                    this.$root.getCurrentPathName();
                    this.isCheckoutPageCount++;

                    if (this.order.order == null) {
                        this.$router.replace("/checkout");
                    }
                } else if (to.path === '/checkout') {
                    this.isCheckoutPage = true;
                    this.$root.getCurrentPathName();
                    this.isCheckoutPageCount++;
                }
            },
            /*
            'cart.member': function (member) {
                if (member == null) {
                    //this.$root.ReloadCurrentPage();
                    this.$router.push('/');
                }
            }
            */
        },
        methods: {
            goBack() {
                /*
                if (this.info.order) {
                    this.$root
                        .wsPost(
                            this.info.wsUrl + "/order/cancelorder",
                            this.lang,
                            JSON.stringify({
                                data: {
                                    orderNo: this.info.order.orderNo,
                                },
                            }),
                            (data) => { }
                        )
                        .fail(() => { });

                    this.$root.removeOrderData();
                }
                */
                return false;
            },
            getItemSubfix() {
                return this.$root.getItemSubfix();
            },
            CouponDiscountCodeLabel() {
                if (this.info.enableCouponCode) {
                    return this.label['checkout_text_coupon_discountcode'];
                }
                else {
                    return this.label['checkout_text_discountcode'];
                }
            },

            setQuoteTime(item) {
                this.quoteTime = item;
                this.closeQuoteTimePanel();
                this.checkCanSubmit();
            },
            getQuoteTimelabel(time) {
                if (time == 1) return this.label["quote_time_makenow_label"];
                else return time + this.label["quote_time_suffix_label"];
            },
            openQuoteTimePanel() {
                if (this.showQuoteTimePanel) {
                    this.showQuoteTimePanel = false;
                } else {
                    this.showQuoteTimePanel = true;
                }
            },
            closeQuoteTimePanel() {
                this.showQuoteTimePanel = false;
            },

            setPayMethod(pay) {
                //this.payMethod = pay;
                this.$root.tempPaymentMethod = pay;
                this.payMethodTemp = this.pay;
                this.closePayMethodPanel();
                this.checkCanSubmit();
            },
            openPayMethodPanel() {
                if (this.showPayMethodPanel) {
                    this.showPayMethodPanel = false;
                } else {
                    this.showPayMethodPanel = true;
                }
            },
            closePayMethodPanel() {
                this.showPayMethodPanel = false;
            },
            setPayMethodNormal(pay) {
                var app = this;
                if (pay != undefined && pay != null) {
                    if (app.checkPayMethodInCoupon(pay)) {
                        //app.payMethod = pay;
                        app.$root.tempPaymentMethod = pay;
                        app.payMethodTemp = pay;

                        app.$root.UpdateTempPayMethod(function () { });
                        app.checkCanSubmit();
                    }
                }
                else {
                    //app.payMethod = undefined;
                    app.$root.tempPaymentMethod = undefined;
                    app.payMethodTemp = undefined;

                    app.$root.UpdateTempPayMethod(function () { });
                    app.checkCanSubmit();
                }                
            },
            setPayMethodTemp(pay) {
                var app = this;
                if (pay != undefined && pay != null) {
                    if (app.checkPayMethodInCoupon(pay)) {
                        app.payMethodTemp = pay;
                    }
                }
                else {
                    app.payMethodTemp = pay;
                }
            },
            setPayMethodLayer() {
                var app = this;
                //app.payMethod = JSON.parse(JSON.stringify(app.payMethodTemp));
                app.$root.tempPaymentMethod = JSON.parse(JSON.stringify(app.payMethodTemp));

                app.$root.UpdateTempPayMethod(function () {
                    //app.payMethodTemp = undefined;
                    app.closePayMethodPanelLayer();
                    app.checkCanSubmit();
                });                
            },
            openPayMethodPanelLayer() {
                /*if (this.payMethod != undefined) {
                    this.payMethodTemp = JSON.parse(JSON.stringify(this.payMethod));
                }*/
                if (this.$root.tempPaymentMethod != undefined) {
                    this.payMethodTemp = JSON.parse(JSON.stringify(this.$root.tempPaymentMethod));
                }
                else {
                    this.payMethodTemp = undefined;
                }
                this.showPayMethodPanelLayer = true;    
                this.$root.setBodyOverflow(true);
            },
            closePayMethodPanelLayer() {
                this.payMethodTemp = undefined;
                this.showPayMethodPanelLayer = false;
                this.$root.setBodyOverflow(false);
            },
            getPayMethodlabel() {
                /*
                if (this.payMethod == undefined) {
                    return "noPayMethodod";
                } else {
                    return this.payMethod["name" + this.getItemSubfix()];
                }
                */
                if (this.$root.tempPaymentMethod == undefined) {
                    return "noPayMethodod";
                } else {
                    return this.$root.tempPaymentMethod["name" + this.getItemSubfix()];
                }
            },
            getPayMethodObj(method_obj) {
                var m = this.payMethodList.filter(a => a.code == method_obj.code);
                if (m.length > 0) {
                    return m[0];
                }
                else {
                    return method_obj
                }
            },
            getPayMethodObjByCode(method_code) {
                var m = this.payMethodList.filter(a => a.code == method_code);
                if (m.length > 0) {
                    return m[0];
                }
                else {
                    return null;
                }
            },

            setDeliveryMessage(msg) {
                var app = this;
                var count_msg = 0;
                var select_msg = -1;
                $.each(app.cart.remarkDeliveryObj, function (i, d) {
                    if (d.code == msg.code) {
                        select_msg = i;
                        return true;
                    }
                    else {
                        count_msg++;
                    }
                });
                if (count_msg == app.cart.remarkDeliveryObj.length) {
                    app.cart.remarkDeliveryObj.push(msg);
                }
                else {
                    app.cart.remarkDeliveryObj.splice(select_msg, 1);
                }
                /*
                app.cart.remarkDelivery = "";
                $.each(app.cart.remarkDeliveryObj, function (i, d) {
                    app.cart.remarkDelivery = app.cart.remarkDelivery + d["msg_1"] + "\r\n" + d["msg_2"] + "\r\n";
                });
                */
                this.cart.saveCart();
                //this.closeDeliveryMessagePanel();
            },
            openDeliveryMessagePanel() {
                if (this.showDeliveryMessagePanel) {
                    this.showDeliveryMessagePanel = false;
                } else {
                    this.showDeliveryMessagePanel = true;
                }
            },
            closeDeliveryMessagePanel() {
                this.showDeliveryMessagePanel = false;
            },
            getDeliveryMessagelabel() {
                var app = this;
                var msg = "";
                if (this.showDeliveryMessagePanel == true) {
                    msg = app.label['checkout_delivery_remark_text'];
                }
                else {
                    if (app.cart.remarkDeliveryObj.length == 0) {
                        msg = app.label['checkout_delivery_remark_text'];
                    } else {
                        $.each(app.cart.remarkDeliveryObj, function (i, d) {
                            msg = msg + d["msg_" + app.getItemSubfix()] + "<br/>";
                        });
                    }
                }
                return msg;
            },
            checkDeliveryMessageIsClick(msg) {
                var re = false;
                $.each(this.cart.remarkDeliveryObj, function (i, d) {
                    if (d.code == msg.code) {
                        re = true;
                        return true;
                    }
                });
                return re;
            },

            setDeliveryMethodList(data, cb) {
                var app = this;
                
                // reset data
                var oldDeliveryMethod = JSON.parse(JSON.stringify(app.cart.deliveryMethod));
                app.DeliveryMethodList = [];
                app.cart.deliveryMethod = null;
                if (app.$root.info.order_temp_info.order_type == 'pickup') {
                    app.cart.address = "";
                    app.cart.address_full_1 = "";
                    app.cart.address_full_2 = "";
                    app.cart.address_full_3 = "";
                    app.cart.addressDetails = null;
                }
                
                /*
                this.$root.updateCart(function () {
                    app.cart.saveCart();

                    if (data != null) {
                        $.each(data.list, function (i, d) {
                            if (d.shopCode.indexOf(app.cart.shop.shopCode) >= 0) {
                                if (d.orderType.indexOf(parseInt(app.$root.getCurrentOrderTypeSubfix, 10)) >= 0) {
                                    app.DeliveryMethodList.push(d);
                                }
                            }
                        });
                    }

                    if (cb) cb();
                }, false, false);
                */

                // change to not updateCart
                if (data != null) {
                    $.each(data.list, function (i, d) {
                        if (d.shopCode.indexOf(app.cart.shop.shopCode_global) >= 0) {
                            if (d.orderType.indexOf(parseInt(app.$root.getCurrentOrderTypeSubfix, 10)) >= 0) {
                                app.DeliveryMethodList.push(d);
                            }
                        }
                    });

                    if (oldDeliveryMethod != null) {
                        app.cart.deliveryMethod = oldDeliveryMethod;
                        var dm = app.GetDeliveryMethodByCode(oldDeliveryMethod.code);
                        if (dm.length > 0) {
                            app.lockerOptionLayerObj.lockerOption = dm[0].lockerOption;
                        }
                    }
                }
                if (cb) cb();


            },
            setDeliveryMethod(m) {
                var app = this;

                // check deliveryMethod lockerOption                
                var old_method = (app.cart.deliveryMethod == null ? [] : app.GetDeliveryMethodByCode(app.cart.deliveryMethod.code));
                app.cart.deliveryMethod = m;
                if (old_method.length > 0 && old_method[0].lockerOption != m.lockerOption) {
                    app.cart.address = "";
                    app.cart.address_full_1 = "";
                    app.cart.address_full_2 = "";
                    app.cart.address_full_3 = "";
                    app.cart.addressDetails = null;
                }

                this.$root.updateCart(function () {
                    app.cart.saveCart();
                    app.closeDeliveryMethodPanel();
                    app.CheckDeliveryMethodLockerOption();
                }, false);                
            },
            openDeliveryMethodPanel() {
                if (this.showDeliveryMethodPanel) {
                    this.showDeliveryMethodPanel = false;
                } else {
                    this.showDeliveryMethodPanel = true;
                }
            },
            closeDeliveryMethodPanel() {
                this.showDeliveryMethodPanel = false;
            },
            GetDeliveryMethodByCode(deliveryMethod_code) {
                return this.DeliveryMethodList.filter(a => a.code == deliveryMethod_code);
            },
            getDeliveryMethodlabel() {
                var app = this;
                if (app.cart.deliveryMethod != null) {
                    var dm = app.GetDeliveryMethodByCode(app.cart.deliveryMethod.code);
                    if (dm.length > 0) {
                        return dm[0]["name" + this.getItemSubfix()];
                    }
                    else {
                        app.cart.deliveryMethod = null;
                        app.$root.updateCart(function () {
                            app.cart.saveCart();
                        }, false);
                        return app.label['checkout_please_select_delivery_method_text'];
                    }

                } else {
                    return app.label['checkout_please_select_delivery_method_text'];
                }
            },

            checkOrderAddressContact(isAlert) {
                if (this.$root.CheckOrderOrderTypeIdx(this.cart) == 1) {
                    if (this.info.order_temp_info.order_address != null) {
                        if (((this.info.order_temp_info.order_address.block == '' || this.info.order_temp_info.order_address.block == undefined) && this.info.order_temp_info.order_address.flat == '' && this.info.order_temp_info.order_address.floor == '') || this.info.order_temp_info.order_contact_info == null) {
                            if (isAlert)
                                this.$root.alert('modify_address_alert_please_fill_correct_address_and_contact_info');

                            return false;
                        }
                        else {
                            return true;
                        }
                    } else {
                        return false;
                    }
                }
                else {
                    return true;
                }
            },
            SubmitCheckDeliveryMethod() {
                var re = false;

                if (this.DeliveryMethodList.length <= 0) {
                    re = true;
                }
                else {
                    if (this.cart.deliveryMethod != null) {

                        if (this.lockerOptionLayerObj.lockerOption != '') {
                            if (this.cart.address == null || this.cart.address == "") {
                                return false;
                            }
                            else {
                                if (this.getDeliveryMethodLockerOptionDisplaylabelCheck() == null) {
                                    return false;
                                }
                                else {
                                    return true;
                                }
                            }
                        }
                        else {
                            re = true;
                        }


                    }
                    else {
                        re = false;
                    }
                }

                return re;
            },
            checkCanSubmit(isAlert) {
                this.canSubmitOrder = this.checkCanSubmitReturn(isAlert);
            },
            checkCanSubmitReturn(isAlert) {
                var checkPass = false;
                if (this.$root.CheckOrderModeIsShopping) {
                    // for pickupShop
                    if (this.$root.CheckOrderOrderTypeIdx(this.cart) == 3) {
                        if (this.cart.pickupShopCode != "tempPickupShop") {
                            if (this.cart.pickupShopCode == null || this.cart.pickupShopCode == "") {
                                if (isAlert)
                                    this.$root.alert('checkout_please_select_pickupShop');
                            }
                            else {
                                checkPass = true;
                            }                            
                        }
                        else {
                            if (isAlert)
                                this.$root.alert('checkout_please_select_pickupShop');
                        }
                    }
                    // for pickup
                    else if (this.$root.CheckOrderOrderTypeIdx(this.cart) == 2 ) {
                        checkPass = true;
                    }
                    // for delivery
                    else if (this.$root.CheckOrderOrderTypeIdx(this.cart) == 1) {
                        if (this.info.order_temp_info.order_address != null) {
                            checkPass = true;
                        }
                        else {
                            if (isAlert)
                                this.$root.alert('checkout_please_input_delivery_address');
                        }
                    }
                }
                else {
                    checkPass = true; // pass for ordering mode
                }

                if (checkPass) {
                    if (this.checkMinChargeText() == "") {
                        //if (this.quoteTime != 0 && !(this.cart.amount > 0 && this.payMethod == undefined)) {
                        if (this.quoteTime != 0 && !(this.cart.amount > 0 && this.$root.tempPaymentMethod == undefined)) {
                            if (this.checkOrderAddressContact(isAlert)) {

                                if (this.SubmitCheckDeliveryMethod()) {

                                    if (this.cart.member != null) {

                                        if (this.checkTNCisTick(isAlert)) {
                                            return true;
                                        }
                                        else {
                                            return false;
                                        }

                                    }
                                    else {

                                        if (this.info.allowGuestMode) {
                                            // guest mode profile
                                            if (this.$root.CheckOrderOrderTypeIdx(this.cart) == 2 || this.$root.CheckOrderOrderTypeIdx(this.cart) == 3) {
                                                if (this.guestModeTypeTwo.orderName != '' && this.guestModeTypeTwo.orderPhone != '' && this.guestModeTypeTwo.orderEmail != '') {

                                                    if (this.checkTNCisTick(isAlert)) {
                                                        return true;
                                                    }
                                                    else {
                                                        return false;
                                                    }

                                                }
                                                else {
                                                    return false;
                                                }
                                            }
                                            else {
                                                if (this.cart.name != '' && this.cart.email != '' && this.cart.phone != '') {

                                                    if (this.checkTNCisTick(isAlert)) {
                                                        return true;
                                                    }
                                                    else {
                                                        return false;
                                                    }

                                                }
                                                else {
                                                    return false;
                                                }
                                            }
                                        } // end check allowGuestMode
                                        else {
                                            return false;
                                        }

                                    } // end check member

                                } // end check DeliveryMethodList
                                else {
                                    if (isAlert)
                                        this.$root.alert('checkout_please_select_delivery_method_text');

                                    return false;
                                }
                            } // end check checkOrderAddressContact
                            else {
                                return false;
                            }
                        } else {
                            //if (this.cart.amount > 0 && this.payMethod == undefined && isAlert)
                            if (this.cart.amount > 0 && this.$root.tempPaymentMethod == undefined && isAlert)
                                this.$root.alert('checkout_please_select_payment_method_text');

                            return false;
                        }
                    }
                    else {
                        if (isAlert)
                            this.$root.alert(this.checkMinChargeText());

                        return false;
                    }
                }                
            },
            checkTNCisTick(isAlert) {
                if (this.isTickCheckoutTNC) {
                    return true;
                }
                else {
                    if (isAlert) this.$root.alert(this.label['checkout_text_please_confirm_tnc']);
                    return false;
                }
            },
            
            payCb() {
                var app = this;
                var check_data = false;

                if (this.isStaffAccount) {
                    if (this.customerInfo.orderCustomerName != "" && this.customerInfo.orderCustomerPhone != "" && this.customerInfo.orderCustomerEmail != "") {
                        if (this.$root.CheckPhoneFormat(this.customerInfo.orderCustomerPhone)) {
                            if (ValidateEmail(this.customerInfo.orderCustomerEmail)) {

                                if (this.customerInfo.orderCustomerEmail == this.customerInfo.orderCustomerConfirmEmail) {
                                    check_data = true;
                                }
                                else {
                                    this.$root.alert("confirmationEmail.notMatch");
                                }

                            }
                            else {
                                this.$root.alert("email.invalid");
                            }
                        }
                        else {
                            this.$root.alert("tel.invalid");
                        }
                    }
                    else {
                        this.$root.alert('checkout_order_please_input_customer_info');
                    }
                }
                else {
                    check_data = true;
                }
                if (!check_data) {
                    //this.$root.alert('checkout_order_please_input_customer_info');
                }

                if (check_data) {
                    check_data = false;
                    if (this.cart.member == null && (this.$root.CheckOrderOrderTypeIdx(this.cart) == 2 || this.$root.CheckOrderOrderTypeIdx(this.cart) == 3)) {
                        if (this.guestModeTypeTwo.orderName != '' && this.guestModeTypeTwo.orderPhone != '' && this.guestModeTypeTwo.orderEmail != '') {
                            if (this.$root.CheckPhoneFormat(this.guestModeTypeTwo.orderPhone)) {
                                if (ValidateEmail(this.guestModeTypeTwo.orderEmail)) {

                                    if (this.guestModeTypeTwo.orderEmail == this.guestModeTypeTwo.orderConfirmEmail) {
                                        check_data = true;
                                    }
                                    else {
                                        this.$root.alert("confirmationEmail.notMatch");
                                    }

                                }
                                else {
                                    this.$root.alert("email.invalid");
                                }
                            }
                            else {
                                this.$root.alert("tel.invalid");
                            }
                        }
                        else {
                            this.$root.alert('checkout_order_please_input_customer_info');
                        }
                    }
                    else {
                        check_data = true;
                    }
                }
                if (!check_data) {
                    //this.$root.alert('checkout_order_please_input_customer_info');
                }

                if (check_data) {
                    // save remark                
                    this.checkCanSubmit(true);
                    if (this.canSubmitOrder) {

                        this.checkAmountPayMethod();

                        // check paymethod
                        //if (this.payMethod == undefined) {
                        if (this.$root.tempPaymentMethod == undefined) {
                            check_data = false;
                            return;
                        }

                        // check shop and update LLShop List if shop is offline
                        if (check_data) {
                            app.info.loading = true;
                            app.$root.checkShopCodeIsActive(app.cart.shop.shopCode.substring(0, app.cart.shop.shopCode.length - 2), app.payCb2)
                        }

                    } // end global common canSubmitOrder
                } // end first check_data
            },
            payCb2(checkShop) {
                var app = this;
                if (!checkShop) {
                    app.$root.updateCurrentLLShopList(function () {
                        app.$root.alert("shop.offline");
                        //app.$router.replace("/shop");
                        app.$router.replace("/");
                        app.info.loading = false;
                    });                    
                }
                else {
                    var check_data = true;

                    // check menu time (after check shop)
                    if (check_data) {
                        if (!app.$root.CartCheckOrderMenuTimeExpiry(false)) {
                            check_data = false;
                            app.$router.replace("/menu");
                        }
                    }

                    if (check_data) {
                        app.cart.remark = app.orderRemark == null ? "" : app.orderRemark;
                        app.cart.updateCartOrderInfo(app.info.order_temp_info, app.info.lang);
                        app.cart.saveCart();

                        
                        var needUpdateCart = false;

                        // check needCutlery
                        if (!app.isCheckoutPage) {
                            if (app.cart.needCutlery) {
                                needUpdateCart = true;
                                app.cartRemoveExtraRemark();

                                if (app.cart.remark != null && app.cart.remark != "") {
                                    app.cart.remark = app.cart.remark + "\r\n" + app.label['order_need_extra_items_remark_msg'];
                                } else {
                                    app.cart.remark = app.label['order_need_extra_items_remark_msg'];
                                }
                            }
                        }

                        // check is staff account
                        if (app.isStaffAccount) {
                            needUpdateCart = true;
                            app.cart.gender = "";
                            app.cart.name = app.customerInfo.orderCustomerName;
                            app.cart.email = app.customerInfo.orderCustomerEmail;
                            app.cart.phone = app.customerInfo.orderCustomerPhone;
                            app.cart.phone_countryCode = app.customerInfo.orderCustomerPhone_countryCode;
                        }

                        // check is guest mode and order type = 2
                        if (app.cart.member == null && (app.$root.CheckOrderOrderTypeIdx(app.cart) == 2 || app.$root.CheckOrderOrderTypeIdx(app.cart) == 3)) {
                            needUpdateCart = true;
                            app.cart.gender = "";
                            app.cart.name = app.guestModeTypeTwo.orderName;
                            app.cart.email = app.guestModeTypeTwo.orderEmail;
                            app.cart.phone = app.guestModeTypeTwo.orderPhone;
                            app.cart.phone_countryCode = app.guestModeTypeTwo.orderPhone_countryCode;
                        }

                        if (app.$root.CheckOrderModeIsShopping && (app.$root.CheckOrderOrderTypeIdx(app.cart) == 2 || app.$root.CheckOrderOrderTypeIdx(app.cart) == 3)) {
                            needUpdateCart = true;
                            //app.cart.address = app.cart['address_full_' + app.getItemSubfix()];
                            app.cart.addressDetails = null;
                        }
                        else {
                            if (app.info.order_temp_info.order_address != null) {
                                app.cart.addressDetails = {
                                    address_zh: app.info.order_temp_info.order_address.address_zh,
                                    address_en: app.info.order_temp_info.order_address.address_en,
                                    address_sc: app.info.order_temp_info.order_address.address_sc,
                                    address_block: app.info.order_temp_info.order_address.block,
                                    address_floor: app.info.order_temp_info.order_address.floor,
                                    address_flat: app.info.order_temp_info.order_address.flat,
                                    location: app.info.order_temp_info.order_address.location
                                };
                            }
                            else {
                                app.cart.addressDetails = null;
                            }
                        }

                        app.cart.remarkDelivery = "";
                        app.cart.remarkDelivery_en = "";
                        app.cart.remarkDelivery_zh = "";
                        $.each(app.cart.remarkDeliveryObj, function (i, d) {
                            app.cart.remarkDelivery = app.cart.remarkDelivery + d["msg_1"] + "\r\n" + d["msg_2"] + "\r\n";
                            app.cart.remarkDelivery_en = app.cart.remarkDelivery_en + d["msg_2"] + "\r\n";
                            app.cart.remarkDelivery_zh = app.cart.remarkDelivery_zh + d["msg_1"] + "\r\n";
                        });

                        // check orderType
                        if (app.$root.CheckOrderOrderTypeIdx(app.cart) == 3) {
                            app.cart.address = "";
                            app.cart.address_full_1 = "";
                            app.cart.address_full_2 = "";
                            app.cart.address_full_3 = "";
                            app.cart.addressDetails = null;
                        }                        

                        // check cart data
                        /*
                        if (needUpdateCart) {
                            this.$root.updateCart(this.updatePay, false);
                        }
                        else {
                            this.$root.saveOrderCb(this.pay);
                        }
                        */
                        // must call updateCart for checking
                        app.$root.updateCart(app.updatePay, false);
                    }

                }
            },
            updatePay() {
                /*
                //if (this.cart.member != null) {
                if (this.cart.name != '' && this.cart.email != '' && this.cart.phone != '') {
                    if (this.canSubmitOrder) {                        
                        this.$root.saveOrderCb(this.pay);
                    }
                }
                */
                if (this.isCheckoutPage) {                    
                    if (this.canSubmitOrder) {
                        this.order.order = JSON.parse(JSON.stringify(this.cart));
                        console.log("this.order.order", this.order.order);
                        this.$router.push("/preview");
                    }
                }
                else {
                    if (this.canSubmitOrder) {
                        this.$root.saveOrderCb(this.pay);
                    }
                    else {
                        this.$router.back(-1);
                    }
                }

            },
            checkAmountPayMethod() {
                /*
                if (this.cart.amount <= 0) {
                    if (this.cart.usedECash > 0) {
                        this.payMethod = {
                            code: "ecash",
                            name1: "ecash",
                            name2: "ecash",
                            name3: "ecash",
                            image: ""
                        };
                    }
                    else if (this.cart.coupons.length > 0) {
                        this.payMethod = {
                            code: "coupon",
                            name1: "coupon",
                            name2: "coupon",
                            name3: "coupon",
                            image: ""
                        };
                    }
                    else {
                        this.payMethod = {
                            code: "cash",
                            name1: "cash",
                            name2: "cash",
                            name3: "cash",
                            image: ""
                        };
                    }
                }
                */
                if (this.cart.amount <= 0) {
                    if (this.cart.usedECash > 0) {
                        this.$root.tempPaymentMethod = {
                            code: "ecash",
                            name1: "ecash",
                            name2: "ecash",
                            name3: "ecash",
                            image: ""
                        };
                    }
                    else if (this.cart.coupons.length > 0) {
                        this.$root.tempPaymentMethod = {
                            code: "coupon",
                            name1: "coupon",
                            name2: "coupon",
                            name3: "coupon",
                            image: ""
                        };
                    }
                    else if (this.cart.couponCode == undefined || this.cart.couponCode == null || this.cart.couponCode != "") {
                        this.$root.tempPaymentMethod = {
                            code: "couponCode",
                            name1: "couponCode",
                            name2: "couponCode",
                            name3: "couponCode",
                            image: ""
                        };
                    }
                    else {
                        this.$root.tempPaymentMethod = {
                            code: "cash",
                            name1: "cash",
                            name2: "cash",
                            name3: "cash",
                            image: ""
                        };
                    }
                }
            },
            pay(saveorder_data) {                
                if (!this.info.allowGuestMode && this.cart.member == null) {
                    this.$root.page_after_login = "/checkout";
                    this.$router.replace("/guestlogin");
                }
                else {
                    var app = this;
                    //if (this.cart.member != null) {                
                    if (this.cart.name != '' && this.cart.email != '' && this.cart.phone != '') {
                        if (this.canSubmitOrder) {

                            // check savePreferShop
                            if (app.$root.CheckOrderModeIsShopping) {
                                app.cart.savePreferShop = false;
                            }
                            else {                                
                                app.cart.savePreferShop = app.isTickSavePreferShop;
                                if (app.cart.savePreferShop)
                                    app.$root.UpdateMemberPreferShopCode(app.cart.shop.shopCode_global, true);
                            }

                            app.checkAmountPayMethod();

                            //if (this.payMethod == undefined) return;
                            if (app.$root.tempPaymentMethod == undefined) return;

                            //save orderNo to app before submitorder
                            SaveWebViewOrderNo(app.info.order_temp_info.order_device, saveorder_data.cart.orderNo);
                            
                            app.info.loading = true;
                            app.$root
                                .wsPost(
                                    app.info.wsUrl + "/order/submitorder",
                                    app.lang,
                                    JSON.stringify({
                                        data: {
                                            deviceType: app.info.order_temp_info.order_device == "web" ? "" : app.info.order_temp_info.order_device,
                                            //orderNo: app.info.order.orderNo,
                                            paymentNo: app.info.order.paymentNo,
                                            //paymentMethod: app.payMethod.code,
                                            paymentMethod: app.$root.tempPaymentMethod.code,
                                            quoteTime: app.quoteTime,
                                            readyTime: (app.info.readyTimeDays > 0 ? app.$root.OrderDateSelect.add(app.info.readyTimeDays, 'days').format("YYYY-MM-DD HH:mm") + ":00" : app.$root.OrderDateSelect.format("YYYY-MM-DD HH:mm") + ":00") 
                                        },
                                    }),
                                    (data) => {
                                        console.log("pay", data);
                                        if (data.status == 0) {
                                            app.info.orderResult = data;
                                            if (data.sent) app.$router.push("confirmation");
                                            else {
                                                if (data.paymentMethod == "qrcode") {
                                                    app.info.loading = false;
                                                    app.showPaymentQrcode(data);
                                                    return;
                                                }
                                                if (data.url) {
                                                    window.setTimeout(function () { app.$root.ReloadCurrentPage(); }, 5000); // for checking window back

                                                    //app.$root.removeOrderData(); // clear info.order before going to payment page

                                                    app.info.loading = true;
                                                    var url = data.url;
                                                    if (url.indexOf("http") != 0) url = app.info.wsHost + url;

                                                    var callOpenUrl = false;
                                                    if (app.info.order_temp_info.order_device == "ios") {
                                                        if (app.$root.ios_payMethod_openURL.indexOf(app.$root.tempPaymentMethod.code) >= 0) {
                                                            callOpenUrl = true;
                                                        }
                                                    }
                                                    else if (app.info.order_temp_info.order_device == "android") {
                                                        if (app.$root.android_payMethod_openURL.indexOf(app.$root.tempPaymentMethod.code) >= 0) {
                                                            callOpenUrl = true;
                                                        }
                                                    }

                                                    if (callOpenUrl) {
                                                        WebopenURL(app.info.order_temp_info.order_device, url);
                                                    }
                                                    else {
                                                        if (
                                                            data.urlMethod &&
                                                            data.urlMethod.toLocaleLowerCase() == "post"
                                                        ) {
                                                            $('<form method="POST">').attr("action", url).appendTo('body').submit();
                                                        } else window.location = url;
                                                        return;
                                                    }

                                                }
                                            }
                                        } else {
                                            var message = "";
                                            var data_msg = data.message.replace("EXMessage: ", "");
                                            if (data_msg == "item.not.available.time") {
                                                message = app.label[data_msg] || data_msg;
                                                $.each(data.invalidItems, (i, item) => {
                                                    message += "<br/>" + item["name" + app.getItemSubfix()];
                                                });
                                            }
                                            if (message != "") 
                                                app.$root.alert(message);
                                            else 
                                                app.$root.alert(data.message);
                                        }
                                        app.info.loading = false;
                                    }
                                )
                                .fail(() => {
                                    app.info.loading = false;
                                    //alert("Fail!");
                                    app.$root.alert("common_fail_message");
                                });
                            //submit payment end

                        }

                    }
                    else {
                        //this.$root.page_after_login = "/checkout";
                        //app.$router.push("/guestlogin");
                    }
                }
            },
            showPaymentQrcode(qrcodeData) {
                //console.log(qrcodeText);
                var app = this;
                var qrcodeText = qrcodeData.url;
                if (qrcodeText) {                    
                    //app.QRCodeHeader = app.label["qrcode_header_" + app.payMethod.code];
                    app.QRCodeHeader = app.label["qrcode_header_" + app.$root.tempPaymentMethod.code];
                    app.showQrcodePanel = true;
                    app.$nextTick(function () {
                        if (app.$refs.qrcode) {
                            new QRCode(app.$refs.qrcode, {
                                text: qrcodeText,
                                width: 300,
                                height: 300,
                                colorDark: "#000000",
                                colorLight: "#ffffff",
                                correctLevel: QRCode.CorrectLevel.H,
                            });
                        }
                    });
                }
                app.checkPayment();
            },
            checkPayment() {
                var app = this;
                app.$root
                    .wsPost(
                        app.info.wsUrl + "/order/submitorder",
                        app.lang,
                        JSON.stringify({
                            data: {
                                orderNo: app.info.order.orderNo,
                            },
                        }),
                        (data) => {
                            console.log("checkPayment", data);
                            if (data.status == 0) {
                                app.info.orderResult = data;
                                if (data.sent || data.exit) {
                                    app.$router.push("confirmation");
                                    return;
                                }
                            }
                            app.checkPaymentTimer = setTimeout(app.checkPayment, 1000);
                        }
                    )
                    .fail(() => {
                        app.checkPaymentTimer = setTimeout(app.checkPayment, 1000);
                    });
            },

            cancelQRPayment() {
                this.showQrcodePanel = false;
                //this.$router.replace("cart");
                this.$router.push("menu");
            },

            continue_shopping() {
                var app = this;
                if (!this.isCheckoutPage) {
                    //this.$router.back(-1);
                    this.$router.replace("/checkout");
                }
                else {
                    app.$root.setConfirmMsg(app.label['confirmation_msg_checkout_page_continue_shopping'], function () { app.$router.push("menu"); }, undefined);
                }                
            },
            cartRemoveExtraRemark() {
                var reg = new RegExp("\r\n"+this.label['order_need_extra_items_remark_msg'], "g");
                this.cart.remark = this.cart.remark.replace(reg, "");
                var reg = new RegExp(this.label['order_need_extra_items_remark_msg'], "g");
                this.cart.remark = this.cart.remark.replace(reg, "");
            },

            /* ecash start */
            /*
            CartCheckoutECashInit() {

                if (this.cart.usedECash > 0) {
                    this.UseECashObj.inUse = true;
                    this.UseECashObj.eCashUse = this.cart.usedECash + "";
                    this.UseECashObj.isError = false;
                } else {
                    this.UseECashObj.inUse = false;
                    this.UseECashObj.eCashUse = "";
                    this.UseECashObj.isError = false;
                }
                
            },
            UseECashCheckoutBtnClick() {
                var self = this;
                var ecash_obj = self.$el.querySelector("#checkout_cart_ecash");
                var ecash_temp = ecash_obj.value.replace(/ /g, '');

                if (ecash_temp.length > 0) {
                    var ecash_val = parseInt(ecash_temp, 10);
                    if (isNaN(ecash_val)) ecash_val = 0;
                    if (ecash_val > Math.floor(self.cart.amount)) {
                        ecash_val = Math.floor(self.cart.amount);
                    }

                    if (ecash_val > 0 && ecash_val <= this.cart.member.eCash) {

                        // cal api use ecash
                        self.$root.cartUpdateECashAPI(ecash_val, function () {
                                self.CheckoutListUpdate++;
                                self.UseECashObj.inUse = true;
                                self.UseECashObj.eCashUse = self.cart.usedECash + "";
                                self.UseECashObj.isError = false;
                            });

                    } else {

                        if (ecash_val <= 0) {
                            self.UseECashObj.eCashUse = "";
                        }
                        else {
                            this.UseECashObj.isError = true;
                        }
                    }
                }
                else {
                    ecash_obj.value = ecash_temp;
                    this.UseECashObj.isError = false;
                }
            },
            RemoveECashCheckoutBtnClick() {
                var self = this;
                
                // call api remove ecash                  
                self.$root.cartUpdateECashAPI(0, function () {
                    self.CheckoutListUpdate++;
                    self.UseECashObj.inUse = false;
                });
                
            },
            */
            /* ecash end */


            // guest mode start
            OpenCheckoutModifyAddress() {
                if (this.cart.member != null) {
                    //this.$root.modifyAddressOpen('checkout', this.label['checkout_order_info_select_address_header_text']);
                    this.$root.modifyAddressOpen('checkout', this.$root.ModifyAddressLayerHeaderText());
                }
                else {
                    this.guestModeOpen();
                }
            },
            guestModeOpen() {
                if (this.info.order_temp_info.order_address != null) {
                    this.guestMode.address = JSON.parse(JSON.stringify(this.info.order_temp_info.order_address_sample));
                    this.guestMode.contact_info = JSON.parse(JSON.stringify(this.info.order_temp_info.order_contact_info_sample));
                    this.guestMode.isOpen = true;
                    this.$root.setBodyOverflow(true);
                    this.guestModeAddressEditFillData();
                } else {
                    this.$root.alert("session_timeout_label");
                    this.$router.replace("/");
                }
            },
            guestModeClose() {
                this.guestMode.isOpen = false;
                this.guestMode.address = null;
                this.guestMode.contact_info = null;
                this.$root.setBodyOverflow(false);
            },
            guestModeAddressEditFillData() { 
                if (this.$el != undefined) {
                    var guestMode_address_map_location_input = this.$el.querySelector("#guestMode_address_map_location_input");
                    if (guestMode_address_map_location_input != null) {
                        this.guestMode.address = JSON.parse(JSON.stringify(this.info.order_temp_info.order_address));
                        if (this.info.order_temp_info.order_contact_info != null) {
                            this.guestMode.contact_info = JSON.parse(JSON.stringify(this.info.order_temp_info.order_contact_info));
                        }
                        guestMode_address_map_location_input.value = this.guestMode.address['address_' + this.info.lang];
                        var guestMode_address_location = this.guestMode.address['location'].split(',');
                        $(guestMode_address_map_location_input).data("oldValue", { "address_zh": this.guestMode.address['address_zh'], "address_en": this.guestMode.address['address_en'], "address_sc": this.guestMode.address['address_sc'], "latitude": guestMode_address_location[0], "longitude": guestMode_address_location[1] });
                    } else {
                        setTimeout(this.guestModeAddressEditFillData, 100);
                    }
                } else {
                    setTimeout(this.guestModeAddressEditFillData, 100);
                }
            },
            guestModeAddressEditCheckCanSubmit(isAlert) {
                if (this.guestMode.address.address_en != '' && !((this.guestMode.address.block == '' || this.guestMode.address.block == undefined) && this.guestMode.address.flat == '' && this.guestMode.address.floor == '') && this.guestMode.contact_info.name != '' && this.guestMode.contact_info.tel != '' && this.guestMode.contact_info.email != '') {
                    if (this.$root.CheckPhoneFormat(this.guestMode.contact_info.tel)) {
                        if (ValidateEmail(this.guestMode.contact_info.email)) {
                            return true;
                        }
                        else {
                            if (isAlert)
                                this.$root.alert("email.invalid");
                        }
                    }
                    else {
                        if (isAlert)
                            this.$root.alert("tel.invalid");

                        return false;
                    }
                }
                else {
                    if (isAlert)
                        this.$root.alert("modify_address_alert_please_fill_correct_address_and_contact_info");

                    return false;
                }
            },
            guestModeAddressEditUpdate() {
                if (this.guestModeAddressEditCheckCanSubmit(true)) {         
                    this.cart.gender = "";
                    this.cart.name = this.guestMode.contact_info.name;                    
                    this.cart.email = this.guestMode.contact_info.email;
                    this.cart.phone = this.guestMode.contact_info.tel;
                    this.cart.phone_countryCode = this.guestMode.contact_info.tel_countryCode;
                    this.$root.updateCart(this.guestModeAddressEditUpdateCb, false);
                }
            },
            guestModeAddressEditUpdateCb() {
                this.$root.SetOrderDataAddressContactData(this.info.order_temp_info.order_address_id, this.info.order_temp_info.order_address_type, this.info.order_temp_info.order_address_tag, JSON.parse(JSON.stringify(this.guestMode.address)), JSON.parse(JSON.stringify(this.guestMode.contact_info)));
                this.guestMode.address = null;
                this.guestMode.contact_info = null;
                this.guestMode.isOpen = false;
                this.$root.setBodyOverflow(false);
            },
            guestModeAddressUpdateFullAddress() {
                var zh_str = this.guestMode.address.address_zh + ((this.guestMode.address.block != '' && this.guestMode.address.block != undefined) ? " " + this.guestMode.address.block + "" + allLabel['zh']['modify_address_address_fill_block_text'] + "" : '') + (this.guestMode.address.floor != '' ? " " + this.guestMode.address.floor + "" + allLabel['zh']['modify_address_address_fill_floor_text'] + "" : '') + (this.guestMode.address.flat != '' ? " " + this.guestMode.address.flat + "" + allLabel['zh']['modify_address_address_fill_flat_text']  + "" : '');
                var en_str = (this.guestMode.address.flat != '' ? allLabel['en']['modify_address_address_fill_flat_text'] + " " + this.guestMode.address.flat + ", " : '') + (this.guestMode.address.floor != '' ? allLabel['en']['modify_address_address_fill_floor_text'] + " " + this.guestMode.address.floor + ", " : '') + ((this.guestMode.address.block != '' && this.guestMode.address.block != undefined) ? this.guestMode.address.block + " " + allLabel['en']['modify_address_address_fill_block_text'] + ", " : '') + this.guestMode.address.address_en;
                this.guestMode.address['address_full_zh'] = zh_str;
                this.guestMode.address['address_full_en'] = en_str;
                this.guestMode.address['address_full_sc'] = zh_str;
                this.guestModeAddressUpdateKey();
            },
            guestModeAddressUpdateKey() {
                this.guestMode.guestMode_address_isUpdate++;
            },
            // guest mode end

            // deliveryMethod lockerOption start 
            CheckDeliveryMethodLockerOption(cb) {
                var app = this;
                app.lockerOptionLayerObj.lockerOption = '';
                app.lockerOptionLayerObj.lockerList = [];

                app.lockerOptionLayerObj.selectArea = app.$root.homeSelectShop.homeSelectShopArea;
                app.lockerOptionLayerObj.selectDistrict = app.$root.homeSelectShop.homeSelectShopDistrict;
                if (this.cart.deliveryMethod != null) {
                    var dm = app.GetDeliveryMethodByCode(app.cart.deliveryMethod.code);
                    if (dm.length > 0) {
                        var lockerOption = dm[0].lockerOption;
                        app.lockerOptionLayerObj.lockerOption = lockerOption;
                        if (lockerOption != "") {
                            $.get(
                                "/files/" + lockerOption + ".json",
                                (data) => {

                                    if (app.lockerOptionLayerObj.selectDistrict == "") {
                                        if (app.lockerOptionLayerObj.selectArea != "") {
                                            app.$root.homeSelectShop.homeSelectShopAreaDistrictList.forEach(d => {
                                                if (data[d.districtCode] != undefined && data[d.districtCode] != null) {
                                                    app.lockerOptionLayerObj.lockerList = app.lockerOptionLayerObj.lockerList.concat(data[d.districtCode]);
                                                }
                                            });
                                        }
                                    }
                                    else {
                                        if (data[app.lockerOptionLayerObj.selectDistrict] != undefined && data[app.lockerOptionLayerObj.selectDistrict] != null) {
                                            app.lockerOptionLayerObj.lockerList = data[app.lockerOptionLayerObj.selectDistrict];
                                        }                                        
                                    }

                                    $.each(app.lockerOptionLayerObj.lockerList, (i, l) => {
                                        l["display1"] = app.$root.ContentNewLineHtmlReplace(l.saveValue1);
                                        l["display2"] = app.$root.ContentNewLineHtmlReplace(l.saveValue2);
                                    });

                                    if (cb) cb();
                                },
                                "JSON"
                            );
                        }
                    }
                }
            },
            getDeliveryMethodLockerOptionObj(lockerCode) {
                var dm = this.lockerOptionLayerObj.lockerList.filter(a => a.lockerCode == lockerCode);
                if (dm.length > 0) {
                    return dm[0];
                }
                else {
                    return null;
                }
            },
            getDeliveryMethodLockerOptionDisplaylabelCheck() {
                var app = this;
                if (app.cart.address != null && app.cart.address != '') {
                    var dm = this.getDeliveryMethodLockerOptionObj(app.cart.address);
                    if (dm != null) {
                        return dm;
                    }
                    else {
                        return null;
                    }

                } else {
                    return null;
                }
            },
            getDeliveryMethodLockerOptionDisplaylabel() {
                var app = this;
                var dm = this.getDeliveryMethodLockerOptionDisplaylabelCheck();
                if (dm != null) {
                    return dm["display" + this.getItemSubfix()];
                }
                else {
                    var shopArea = app.$root.getShopAreaObj(app.lockerOptionLayerObj.selectArea);
                    var shopDistrict = app.$root.getShopDistrictObj(app.lockerOptionLayerObj.selectArea, app.lockerOptionLayerObj.selectDistrict);
                    if (shopArea == null || shopDistrict == null) {
                        return this.label['checkout_please_select_delivery_method_locker_option_text'];
                    } else {
                        return this.label['checkout_please_select_delivery_method_locker_option_text'] + "(" + shopArea["areaName" + app.getItemSubfix()] + " - " + shopDistrict["districtName" + app.getItemSubfix()] + ")";
                    }
                }
            },
            openDeliveryMethodLockerOptionSelectLayerInit() {
                var app = this;
                var dm = this.getDeliveryMethodLockerOptionDisplaylabelCheck();
                if (dm != null) {
                    app.lockerOptionLayerObj.selectLocker = JSON.parse(JSON.stringify(dm));
                }
                else {
                    app.lockerOptionLayerObj.selectLocker = null;
                }

                app.lockerOptionLayerObj.selectLockerTemp = JSON.parse(JSON.stringify(app.lockerOptionLayerObj.selectLocker));
            },
            openDeliveryMethodLockerOptionSelectLayer() {
                this.openDeliveryMethodLockerOptionSelectLayerInit();
                this.lockerOptionLayerObj.showLayer = true;
                this.$root.setBodyOverflow(true);
            },
            CloseDeliveryMethodLockerOptionSelectLayer() {
                this.lockerOptionLayerObj.showLayer = false;
                this.$root.setBodyOverflow(false);
            },            
            DeliveryMethodLockerOptionSelectLayerConfirm() {
                var app = this;
                if (app.lockerOptionLayerObj.selectLockerTemp != null) {
                    app.lockerOptionLayerObj.selectLocker = JSON.parse(JSON.stringify(app.lockerOptionLayerObj.selectLockerTemp));

                    app.cart.address = app.lockerOptionLayerObj.selectLocker.lockerCode;
                    app.cart.address_full_1 = app.lockerOptionLayerObj.selectLocker.saveValue1;
                    app.cart.address_full_2 = app.lockerOptionLayerObj.selectLocker.saveValue2;
                    app.cart.address_full_3 = app.lockerOptionLayerObj.selectLocker.saveValue3 == undefined ? app.lockerOptionLayerObj.selectLocker.saveValue1 : app.lockerOptionLayerObj.selectLocker.saveValue3;
                    app.cart.addressDetails = null;
                }
                else {
                    app.cart.address = "";
                    app.cart.address_full_1 = "";
                    app.cart.address_full_2 = "";
                    app.cart.address_full_3 = "";
                    app.cart.addressDetails = null;
                }

                app.$root.updateCart(function () {
                    app.cart.saveCart();
                    app.CloseDeliveryMethodLockerOptionSelectLayer();
                }, false);
            },
            DeliveryMethodLockerOptionSelectLayerIsSelect(lockerItem) {
                if (this.lockerOptionLayerObj.selectLockerTemp != null && lockerItem.lockerCode == this.lockerOptionLayerObj.selectLockerTemp.lockerCode) {
                    return true;
                }
                else {
                    return false;
                }
            },            
            DeliveryMethodLockerOptionSelectLayerSelect(lockerItem) {
                this.lockerOptionLayerObj.selectLockerTemp = JSON.parse(JSON.stringify(lockerItem));
            },
            // deliveryMethod lockerOption end

            // check min charge start
            checkMinChargeText() {
                if (this.$root.info.order_setting.FitMinCharge) {
                    return "";
                }
                else {
                    var minCharge = 0;
                    if (this.$root.CheckOrderOrderTypeIdx(this.cart) == 1) {
                        minCharge = this.$root.info.order_setting.deliveryMinCharge;
                    }
                    else if (this.$root.CheckOrderOrderTypeIdx(this.cart) == 2 || this.$root.CheckOrderOrderTypeIdx(this.cart) == 3) {
                        minCharge = this.$root.info.order_setting.pickupMinCharge;
                    }

                    if (this.cart.amountWithoutDiscount < minCharge) {
                        return this.label["checkout_minCharge_alert_text"].replace("#minCharge#", minCharge);
                    }
                    else {
                        return "";
                    }
                }
            },
            checkMinChargeAlert() {
                if (this.$root.info.order_setting.FitMinCharge) {
                    if (this.cart.minCharge > 0) {
                        var minCharge = 0;
                        if (this.$root.CheckOrderOrderTypeIdx(this.cart) == 1) {
                            minCharge = this.$root.info.order_setting.deliveryMinCharge;
                        }
                        else if (this.$root.CheckOrderOrderTypeIdx(this.cart) == 2 || this.$root.CheckOrderOrderTypeIdx(this.cart) == 3) {
                            minCharge = this.$root.info.order_setting.pickupMinCharge;
                        }
                        this.$root.alert(this.label["checkout_minCharge_alert_text"].replace("#minCharge#", minCharge));
                    }
                }                
            },
            // check min charge end

            // check member next level amount start
            checkMemberNextLevelAmountAlert() {
                if (this.cart.member != null) {
                    if (this.cart.member.nextLevelAmount > 0) {
                        var nextAmount = MathPriceRoundWithCal2Dec(this.cart.member.nextLevelAmount - this.cart.amount);
                        if (nextAmount > 0 && nextAmount <= this.info.nextLevelAmountAlert) {
                            this.memberNextLevelAmount.message = this.label["checkout_member_next_level_amount_alert_text"].replace("#nextAmount#", nextAmount);
                            this.memberNextLevelAmount.show = true;
                        }
                        else {
                            this.memberNextLevelAmount.message = "";
                            this.memberNextLevelAmount.show = false;
                        }                        
                    }
                }                
            },
            // check member next level amount end

            // for check order info callback start
            checkoutOrderInfoEdit() {
                var app = this;

                // reload deliveryMethod
                app.setDeliveryMethodList(app.DeliveryMethodListRaw, app.checkoutOrderInfoEditCB);                
            },
            checkoutOrderInfoEditCB() {
                var app = this;
                if (app.DeliveryMethodList.length == 1) {
                    app.setDeliveryMethod(app.DeliveryMethodList[0]);
                }
                else {
                    app.CheckDeliveryMethodLockerOption();
                }

                if (!this.$root.checkShoppingTypeAreaDistrict()) {
                    //this.$router.replace("/"); // hide on 20260715 for moving the select to confirmation page 
                }
            },
            // for check order info callback end

            // tnc start
            openCheckoutTNC() {
                this.isOpenCheckoutTNC = true;
                this.$root.setBodyOverflow(true);
                
                $.ajax({
                    type: "GET",
                    //url: "/files/stand_alone_page/" + this.info.lang + "/checkout_tnc" + this.$root.GetDefaultShopCodeValue() + ".htm",
                    url: "/files/stand_alone_page/" + this.info.lang + "/checkout_tnc.htm",
                    dataType: "html",
                    success: (data) => {
                        console.log(data);
                        this.checkoutTNCHeader = this.label['checkout_text_tnc_header'];
                        this.checkoutTNCContent = data;
                    }
                }).catch(function (e) {
                    console.log(e);
                });
            },
            openCheckoutTNC2() {
                this.isOpenCheckoutTNC = true;
                this.$root.setBodyOverflow(true);
                
                $.ajax({
                    type: "GET",
                    //url: "/files/stand_alone_page/" + this.info.lang + "/checkout_tnc2" + this.$root.GetDefaultShopCodeValue() + ".htm",
                    url: "/files/stand_alone_page/" + this.info.lang + "/checkout_tnc2.htm",
                    dataType: "html",
                    success: (data) => {
                        console.log(data);
                        this.checkoutTNCHeader = this.label['checkout_text_tnc_header2'];
                        this.checkoutTNCContent = data;
                    }
                }).catch(function (e) {
                    console.log(e);
                });
            },
            closeCheckoutTNC() {
                this.isOpenCheckoutTNC = false;

                if (this.isTNCPageBodyFix)
                    this.$root.setBodyOverflow(false);

                this.checkoutTNCContent = "";
                this.isTNCPageBodyFix = true;
            },
            tickCheckoutTNC() {
                if (this.isTickCheckoutTNC)
                    this.isTickCheckoutTNC = false;
                else
                    this.isTickCheckoutTNC = true;
            },
            TickSavePreferShop() {
                if (this.isTickSavePreferShop)
                    this.isTickSavePreferShop = false;
                else
                    this.isTickSavePreferShop = true;
            },
            CheckCanTickSavePreferShop() {
                if (!this.$root.CheckOrderModeIsShopping) {
                    if (this.$root.member_prefer_shop_list.indexOf(this.cart.shop.shopCode_global) < 0)
                        return true;
                    else
                        return false;
                }
                else {
                    return false;
                }
            },
            // tnc end

            /* coupon start */
            checkCanUseCoupon() {
                if (!this.cart.disableDiscount && !this.UseDiscountCodeObj.inUse) {
                    return true;
                }
                else {
                    return false;
                }
            },
            OrderCouponEditLayerInit() {
                if (this.cart.coupons != undefined && this.cart.coupons != null) {
                    this.CheckoutSelectCouponLayerObj.use_coupon = JSON.parse(JSON.stringify(this.cart.coupons));;
                    this.CheckoutSelectCouponLayerObj.select_coupon = JSON.parse(JSON.stringify(this.CheckoutSelectCouponLayerObj.use_coupon));
                }
                else {
                    this.CheckoutSelectCouponLayerObj.use_coupon = [];
                    this.CheckoutSelectCouponLayerObj.select_coupon = [];
                }
            },
            OpenOrderCouponEditLayer() {
                if (this.checkCanUseCoupon()) {
                    var app = this;
                    app.OrderCouponEditLayerInit();

                    // get coupon list                    
                    app.info.loading = true;
                    app.$root.wsGet(
                        app.info.wsUrl + "/Order/GetCouponList?token=" + encodeURIComponent(app.cart.token),
                            app.info.lang,
                            (data) => {
                                console.log("GetCouponList", data);
                                if ((data.aToken != undefined && data.aToken != null && data.aToken != '') && (data.rToken != undefined && data.rToken != null && data.rToken != ''))
                                    UpdateARToken(app.info.order_temp_info.order_device, data.aToken, data.rToken);

                                if (data.status == 0) {                                    
                                    this.CheckoutSelectCouponLayerObj.coupon_list = data.coupons;

                                    this.SetCouponDisplayList();
                                    console.log("display_coupon", app.CheckoutSelectCouponLayerObj.display_coupon);

                                    // open select coupon layer
                                    this.CheckoutSelectCouponLayerObj.showCheckoutSelectCouponLayer = true;
                                    this.$root.setBodyOverflow(true);
                                } else {
                                    app.$root.alert(data.message);
                                }
                            }
                        )
                        .always(() => {
                            app.info.loading = false;
                        })
                        .fail(() => {
                            //app.$root.alert("Fail!");
                            app.$root.alert("common_fail_message");
                        });
                }
            },
            SetCouponDisplayList() {
                var app = this;
                app.CheckoutSelectCouponLayerObj.display_coupon = [];
                $.each(app.CheckoutSelectCouponLayerObj.coupon_list, (i, c) => {
                    c.inUse = app.CheckCouponLayerIsSelect(c);

                    //if (c.isAvailable) {
                        var cidx = app.CheckCouponIsDisplay(c);
                        if (cidx < 0) {
                            c.selectQty = 0;
                            c.couponList = [];
                            c.couponList.push(JSON.parse(JSON.stringify(c)));
                            app.CheckoutSelectCouponLayerObj.display_coupon.push(JSON.parse(JSON.stringify(c)));
                        }
                        else {
                            app.CheckoutSelectCouponLayerObj.display_coupon[cidx].couponList.push(JSON.parse(JSON.stringify(c)));
                        }
                    //}
                });
                multiSort(app.CheckoutSelectCouponLayerObj.display_coupon, { "isAvailable": "desc", "effectiveEndDate": "asc", "couponCode": "asc", "couponId": "asc" });

                app.CheckCouponSelectQty();
            },
            CheckCouponIsDisplay(coupon_object) {
                var cidx = -1;
                $.each(this.CheckoutSelectCouponLayerObj.display_coupon, (i, c) => {
                    if (c.couponId2 == coupon_object.couponId2) {
                        cidx = i;
                        return false;
                    }
                });
                return cidx;
            },
            CheckCouponSelectQty() {
                var app = this;

                $.each(app.CheckoutSelectCouponLayerObj.display_coupon, (i, a) => {
                    a.selectQty = 0;
                    $.each(a.couponList, (j, b) => {
                        if (app.CheckCouponLayerIsSelect(b)) {
                            a.selectQty++;
                        }
                    });
                });
            },
            CloseOrderCouponEditLayer() {
                this.CheckoutSelectCouponLayerObj.showCheckoutSelectCouponLayer = false;
                this.CheckoutSelectCouponLayerObj.select_coupon = [];

                this.OrderCouponEditLayerInit(); // reset coupon status
                this.CartCheckoutDiscountCodeInit(); // reset discount code status

                this.$root.setBodyOverflow(false);
            },
            CouponEditLayerChangeType(layer_type) {
                this.CheckoutSelectCouponLayerObj.display_tag = layer_type;
            },
            OrderCouponLayerEditConfirm() {
                var app = this;

                // call api to update cart coupon use            
                multiSort(app.CheckoutSelectCouponLayerObj.select_coupon, { "isAvailable": "desc", "couponName": "asc", "couponCode": "asc" });
                app.cart.coupons = JSON.parse(JSON.stringify(app.CheckoutSelectCouponLayerObj.select_coupon));

                // remove unuse json key
                $.each(app.cart.coupons, (i, c) => {
                    delete c["selectQty"];
                    delete c["couponList"];
                    delete c["inUse"];
                });
                //console.log("app.cart.coupons", app.cart.coupons);

                //app.$root.updateCart(function (data) { app.OrderCouponLayerEditConfirmCb(data); });
                app.updateOrderCouponCart(function (data) { app.OrderCouponLayerEditConfirmCb(data); });

                // will call close layer in callback
                //app.CloseOrderCouponEditLayer();
            },
            updateOrderCouponCart(cb) {
                var app = this;
                app.info.loading = true;
                app.$root
                    .wsPost(
                        app.info.wsUrl + "/order/updatecart",
                        app.info.lang,
                        JSON.stringify({ data: { token: app.cart.token, cart: app.cart, checkART: false } }),
                        (data) => {
                            app.$root.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                            console.log("updateOrderCouponCart", data);
                            const data_msg = (data.message != undefined && data.message != null) ? data.message.replace("EXMessage: ", "") : "";
                            //$.extend(app.cart, data.cart);
                            //app.cart.saveCart();

                            //if ((data.aToken != undefined && data.aToken != null && data.aToken != '') && (data.rToken != undefined && data.rToken != null && data.rToken != ''))
                                //UpdateARToken(app.info.order_temp_info.order_device, data.aToken, data.rToken);
									
                            if (data.status == 0) {
                                // check success using coupon
                                /*
                                var checkCoupons = true;
                                $.each(app.cart.coupons, (i, c) => {
                                    if (!app.checkPromoCodeInCartDiscount(c.promotionCode, data.cart.discounts)) {
                                        checkCoupons = false;
                                        app.cart.coupons.splice(i, 1);
                                        return false;
                                    }
                                });

                                app.info.loading = false;
                                if (!checkCoupons) {
                                    app.cart.saveCart();
                                    app.$root.updateCart();
                                    app.$root.alert("use.coupon.fail.validate");
                                }
                                else {
                                    $.extend(app.cart, data.cart);
                                    app.cart.saveCart();
                                    if (cb) cb(data);
                                }
                                */

                                // hide checking in frontend, checking will process when calling api updatecart
                                $.extend(app.cart, data.cart);
                                app.cart.saveCart();
                                if (cb) cb(data);
                                app.info.loading = false;

                            } else {
                                app.cart.coupons = [];
                                app.cart.saveCart();
                                app.$root.updateCart();

                                // remove default discount checking on 20260903
                                /*
                                //if (data_msg == "use.coupon.fail.validate" && (data.cart.discounts != null && data.cart.discounts.length > 0)) {
                                if (data_msg.indexOf("use.coupon.fail.validate") >= 0 && (data.cart.discounts != null && data.cart.discounts.length > 0)) {
                                    app.$root.alert("use.coupon.fail.bestDiscountUsing");
                                }
                                else {
                                    app.$root.alert(data.message);
                                }
                                */
                                app.$root.alert(data.message);

                                app.info.loading = false;
                                //app.$root.updateCart();
                            }

                            app.CheckoutListUpdate++;
                        }
                    )
                    .always(() => {
                        //app.info.loading = false;
                    })
                    .fail(() => {
                        //app.$root.alert("Fail!");
                        app.$root.alert("common_fail_message");

                        // clear cart and redirect to select brand when fail
                        app.cart.clearCart();
                        app.$router.push("/");
                    });
            },
            OrderCouponLayerEditConfirmCb(data) {
                //console.log("data", data);
                var app = this;

                if (data.status == 0) {
                    app.CheckoutSelectCouponLayerObj.use_coupon = JSON.parse(JSON.stringify(app.cart.coupons));
                    app.getPaymethodJson(app.cart.paymentCampaign, false);

                    // run rest on close layer
                    //app.OrderCouponEditLayerInit(); // reset coupon status
                    //app.CartCheckoutDiscountCodeInit(); // reset discount code status

                    app.CloseOrderCouponEditLayer(); // close layer when updatecart successfully
                } else {
                    app.$root.alert(data.detail);
                }
            },
            CheckCouponLayerIsSelect(coupon_object) {
                var cidx = -1;
                $.each(this.CheckoutSelectCouponLayerObj.select_coupon, (i, c) => {
                    if (c.couponId == coupon_object.couponId) {
                        cidx = i;
                        return false;
                    }
                });
                if (cidx >= 0) {
                    return true;
                }
                else {
                    return false;
                }
            },
            CheckCouponLayerIsDisplaySelect(coupon_object) {
                var cidx = -1;
                $.each(this.CheckoutSelectCouponLayerObj.select_coupon, (i, c) => {
                    if (c.couponId2 == coupon_object.couponId2) {
                        cidx = i;
                        return false;
                    }
                });
                if (cidx >= 0) {
                    return true;
                }
                else {
                    return false;
                }
            },
            CheckCouponLayerIsAvailable(coupon_object) {
                var app = this;
                var re = false;

                if (coupon_object.isAvailable) {
                    re = true;
                }
                else {
                    /*
                    var temp_coupon = [];
                    $.each(app.CheckoutSelectCouponLayerObj.select_coupon, (i, c) => {
                        
                        // check coupon can use with other discount

                        
                    });
                    */
                    re = false;
                }

                return re;
            },
            CouponLayerSelectCoupon(coupon_object) {
                if (coupon_object.isAvailable) {

                    // check current coupon
                    var cidx = -1;
                    $.each(this.CheckoutSelectCouponLayerObj.select_coupon, (i, c) => {
                        if (c.couponId == coupon_object.couponId) {
                            cidx = i;
                            return false;
                        }
                    });
                     
                    if (cidx >= 0) {
                        // remove select coupon
                        this.CheckoutSelectCouponLayerObj.select_coupon.splice(cidx, 1);
                    } else {

                        // check coupon alow muti
                        if (coupon_object.allowMuti) {
                        }
                        else {
                            var temp_c = null;
                            for (var x = this.CheckoutSelectCouponLayerObj.select_coupon.length; x > 0; x--) {
                                temp_c = this.CheckoutSelectCouponLayerObj.select_coupon[x-1];
                                if (!temp_c.allowMuti) {
                                    this.CheckoutSelectCouponLayerObj.select_coupon.splice(x-1, 1);
                                }
                            }
                        }

                        this.CheckoutSelectCouponLayerObj.select_coupon.push(coupon_object);
                    }                    
                }
            },
            RemoveCouponUseBtnClick() {
                this.CheckoutSelectCouponLayerObj.use_coupon = [];
                this.CheckoutSelectCouponLayerObj.select_coupon = [];
                this.OrderCouponLayerEditConfirm();
            },
            openCouponTNC(coup) {
                this.isOpenCheckoutTNC = true;
                //this.$root.setBodyOverflow(true);
                this.isTNCPageBodyFix = false;
                //this.checkoutTNCContent = coup['couponTNC' + this.getItemSubfix()];
                this.checkoutTNCContent = coup['couponTNC'];
            },
            openCouponRemark(coup) {
                this.isOpenCheckoutTNC = true;
                //this.$root.setBodyOverflow(true);
                this.isTNCPageBodyFix = false;
                this.checkoutTNCContent = coup['couponRemark'];
            },     
            couponSelectTagQtyAdd(coupon_object, type) {
                if (coupon_object.isAvailable) {
                    var app = this;

                    // check contains same coupon group
                    var cidx = -1;
                    $.each(app.CheckoutSelectCouponLayerObj.select_coupon, (i, c) => {
                        if (c.couponId2 == coupon_object.couponId2) {
                            cidx = i;
                            return false;
                        }
                    });

                    if (type == "add") {

                        // remove all not allow muti coupon
                        if (coupon_object.allowMuti) {
                        }
                        else {
                            var temp_c = null;
                            for (var x = app.CheckoutSelectCouponLayerObj.select_coupon.length; x > 0; x--) {
                                temp_c = app.CheckoutSelectCouponLayerObj.select_coupon[x - 1];
                                if (!temp_c.allowMuti) {

                                    if (cidx >= 0) {
                                        if (temp_c.couponId2 != coupon_object.couponId2) {
                                            this.CheckoutSelectCouponLayerObj.select_coupon.splice(x - 1, 1);
                                        }
                                    }
                                    else {
                                        this.CheckoutSelectCouponLayerObj.select_coupon.splice(x - 1, 1);
                                    }
                                }
                            }
                        }

                        // update current qty
                        app.CheckCouponSelectQty();
                        var selectCoupon = null;
                        $.each(app.CheckoutSelectCouponLayerObj.display_coupon, (i, c) => {
                            if (c.couponId2 == coupon_object.couponId2) {
                                selectCoupon = c;
                                return false;
                            }
                        });

 
                        // check can add coupon
                        if ((selectCoupon.selectQty + 1) <= selectCoupon.maxUse && (coupon_object.selectQty + 1) <= selectCoupon.couponList.length) {
                            var addCoupon = selectCoupon.couponList[selectCoupon.selectQty];
                            app.CheckoutSelectCouponLayerObj.select_coupon.push(addCoupon);
                        }
                    }
                    else {

                        // remove same group coupon
                        if (cidx >= 0) {
                            var temp_c = null;
                            for (var x = app.CheckoutSelectCouponLayerObj.select_coupon.length; x > 0; x--) {
                                temp_c = app.CheckoutSelectCouponLayerObj.select_coupon[x - 1];
                                if (temp_c.couponId2 == coupon_object.couponId2) {
                                    app.CheckoutSelectCouponLayerObj.select_coupon.splice(x - 1, 1);
                                    break;
                                }
                            }
                        }

                    }

                    // update current qty
                    app.CheckCouponSelectQty();
                }
            },
            CouponRemovePreview(idx) {
                this.CheckoutSelectCouponLayerObj.use_coupon.splice(idx, 1);
                this.ReCheckEventOrder();
                this.checkoutPageBack();
            },
            checkPayMethodInCoupon(pay) {
                var re = false;
                var app = this;

                if (app.cart.coupons != null && app.cart.coupons.length > 0) {
                    var checkCount = 0;
                    $.each($(app.cart.coupons), function (key, c) {
                        if (c.CouponCriteria_paymentMethod != null && c.CouponCriteria_paymentMethod.length > 0) {
                            if (checkValueInArray(c.CouponCriteria_paymentMethod, pay.code)) {
                                re = true;
                                return false;
                            }
                        }
                        else {
                            checkCount++;
                        }
                    });
                    
                    if (app.cart.coupons.length == checkCount) {
                        re = true;
                    }
                }
                else {
                    re = true;
                }

                return re;
            },
            checkPromoCodeInCartDiscount(promoCode, cartDiscounts) {
                if (cartDiscounts.filter(a => a.promoCode == promoCode).length > 0) {
                    return true;
                }
                else {
                    return false;
                }
            },
            /* coupon end */

            /* discount code start */
            checkCanUseDiscountCode() {
                if (!this.cart.disableDiscount && this.CheckoutSelectCouponLayerObj.use_coupon.length <= 0) {
                    return true;
                }
                else {
                    return false;
                }
            },
            CartCheckoutDiscountCodeInit() {
                if (this.cart.couponCode != undefined  && this.cart.couponCode != "") {
                    this.UseDiscountCodeObj.inUse = true;
                    this.UseDiscountCodeObj.codeUse = this.cart.couponCode;
                    this.UseDiscountCodeObj.isError = false;
                }
                else {
                    this.UseDiscountCodeObj.inUse = false;
                    this.UseDiscountCodeObj.codeUse = "";
                    this.UseDiscountCodeObj.isError = false;
                }             
            },
            UseDiscountCodeCheckoutBtnClick() {
                if (this.checkCanUseDiscountCode()) {
                    var discountCode_obj = this.$el.querySelector("#checkout_cart_discount_code");
                    //var discountCode_val = discountCode_obj.value.replace(/ /g, '');
                    var discountCode_val = discountCode_obj.value.trim();

                    if (discountCode_val.length > 0) {
                        this.UseDiscountCodeCheckEventOrder(discountCode_val);
                    }
                    else {
                        discountCode_obj.value = discountCode_val;
                        this.UseDiscountCodeObj.isError = false;
                    }
                }
            },
            UseDiscountCodeCheckEventOrder(discountCode_val) {
                var app = this;

                // check discount code
                app.info.loading = true;
                app.$root
                    .wsGet(
                        app.info.wsUrl + "/Order/CheckCouponCode?code=" + encodeURIComponent(discountCode_val) + "&token=" + encodeURIComponent(app.cart.token),
                        app.info.lang,
                        (data) => {
                            console.log("CheckCouponCode", data);
                            app.UseDiscountCodeCheckEventOrderCb(data, discountCode_val);
                        }
                    )
                    .always(() => {
                        //app.info.loading = false;
                    })
                    .fail(() => {
                        //app.$root.alert("Fail!");
                        app.info.loading = false;
                        app.$root.alert("common_fail_message");
                    });
            },
            UseDiscountCodeCheckEventOrderCb(data, discountCode_val) {
                //console.log("data", data);
                var app = this;
                if (data.status == 0) {
                    //app.info.loading = false;

                    // cal api use discount code
                    app.cart.couponCode = discountCode_val;
                    app.cart.couponPromoteCode = data.couponPromoteCode;

                    app.$root
                        .wsPost(
                            app.info.wsUrl + "/order/updatecart",
                            app.info.lang,
                            JSON.stringify({ data: { token: app.cart.token, cart: app.cart } }),
                            (data) => {
                                app.$root.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                                console.log("UseDiscountCodeCheckEventOrder", data);
                                const data_msg = (data.message != undefined && data.message != null) ? data.message.replace("EXMessage: ", "") : "";
                                //$.extend(app.cart, data.cart);
                                //app.cart.saveCart();

                                if (data.status == 0) {
                                    
                                    // check success using couponCode
                                    /*
                                    if (!app.checkPromoCodeInCartDiscount(discountCode_val, data.cart.discounts)) {
                                        app.cart.couponCode = "";
                                        app.cart.couponPromoteCode = "";
                                        app.cart.saveCart();
                                        app.$root.updateCart();
                                        app.$root.alert("couponCode.not.valid");
                                    }
                                    else {
                                    */

                                        // hide checking in frontend, checking will process when calling api updatecart
                                        $.extend(app.cart, data.cart);
                                        app.cart.saveCart();

                                        // process if using couponCode successfully
                                        app.OrderCouponEditLayerInit(); // reset coupon status

                                        if (app.cart.couponCode != null && app.cart.couponCode != "") {
                                            app.UseDiscountCodeObj.inUse = true;
                                            app.UseDiscountCodeObj.codeUse = app.cart.couponCode;
                                            app.UseDiscountCodeObj.isError = false;
                                        }
                                        else {
                                            app.UseDiscountCodeObj.inUse = false;
                                            //app.UseDiscountCodeObj.codeUse = "";
                                            app.UseDiscountCodeObj.isError = false;
                                        }

                                    /*
                                    }
                                    */
                                    
                                } else {
                                    app.cart.couponCode = "";
                                    app.cart.couponPromoteCode = "";
                                    app.cart.saveCart();

                                    // remove default discount checking on 20260903
                                    /*
                                    if (data_msg == "couponCode.not.valid" && (data.cart.discounts != null && data.cart.discounts.length > 0)) {
                                        app.$root.alert("use.coupon.fail.bestDiscountUsing");
                                    }
                                    else {
                                        app.$root.alert(data.message);
                                    }
                                    */
                                    app.$root.alert(data.message);

                                    app.info.loading = false;
                                    //app.$root.updateCart();
                                }

                                app.CheckoutListUpdate++;
                            }
                        )
                        .always(() => {
                            //app.info.loading = false;
                        })
                        .fail(() => {
                            //app.$root.alert("Fail!");
                            app.$root.alert("common_fail_message");

                            // clear cart and redirect to select brand when fail
                            app.cart.clearCart();
                            app.$router.push("/");
                        });

                } else {
                    app.info.loading = false;
                    app.UseDiscountCodeObj.isError = true;
                    //app.$root.alert(data.message);
                }
            },
            RemoveDiscountCodeCheckoutBtnClick() {
                var app = this;

                // cal api remove discount code
                app.cart.couponCode = "";
                app.cart.couponPromoteCode = "";
                app.$root.updateCart(function () {
                    app.UseDiscountCodeObj.inUse = false;
                    app.UseDiscountCodeObj.isError = false;
                });
            },
            /* discount code end */

            /* changeShop start */
            ChangeShopChangeLayerInit() {
                var app = this;
                if (app.$root.CheckOrderModeIsShopping) {
                    if (app.$root.getCurrentOrderTypeSubfix == '3') {
                        app.CheckoutChangeShopLayerObj.area_list = [];
                        app.CheckoutChangeShopLayerObj.district_list = [];
                        app.CheckoutChangeShopLayerObj.shop_list = [];

                        $.each(app.$root.AllShopDistrictList, (i, s) => {
                            var temp_shop = app.$root.AllShopList.filter(s2 => (s2.shopType != 'shopping' && s2.visible == 'y' && s2.shopCode.includes("_" + app.$root.getCurrentOrderTypeShopFilterSubfix) && (s2.areaCode == s.areaCode)));
                            if (temp_shop.length > 0)
                                app.CheckoutChangeShopLayerObj.area_list.push(s);
                        });

                        app.CheckoutChangeShopLayerObj.select_area = (app.cart.pickupShop != null && app.cart.pickupShop.areaCode != null && app.cart.pickupShop.areaCode != "" ? app.cart.pickupShop.areaCode : "");
                        app.CheckoutChangeShopLayerObj.select_district = (app.cart.pickupShop != null && app.cart.pickupShop.districtCode != null && app.cart.pickupShop.districtCode != "" ? app.cart.pickupShop.districtCode : "");
                        app.CheckoutChangeShopLayerObj.select_shop = (app.cart.pickupShop != null && app.cart.pickupShop.shopCode_global != null && app.cart.pickupShop.shopCode_global != "" ? app.cart.pickupShop.shopCode_global : "");
                        app.CheckoutChangeShopLayerObj.current_area = (app.cart.pickupShop != null && app.cart.pickupShop.areaCode != null && app.cart.pickupShop.areaCode != "" ? app.cart.pickupShop.areaCode : "");
                        app.CheckoutChangeShopLayerObj.current_district = (app.cart.pickupShop != null && app.cart.pickupShop.districtCode != null && app.cart.pickupShop.districtCode != "" ? app.cart.pickupShop.districtCode : "");
                        app.CheckoutChangeShopLayerObj.current_shop = (app.cart.pickupShop != null && app.cart.pickupShop.shopCode_global != null && app.cart.pickupShop.shopCode_global != "" ? app.cart.pickupShop.shopCode_global : "");
                    }
                    else {
                        app.CheckoutChangeShopLayerObj.area_list = [];
                        app.CheckoutChangeShopLayerObj.district_list = [];
                        app.CheckoutChangeShopLayerObj.shop_list = [];
                        app.CheckoutChangeShopLayerObj.select_area = "";
                        app.CheckoutChangeShopLayerObj.select_district = "";
                        app.CheckoutChangeShopLayerObj.select_shop = "";
                        app.CheckoutChangeShopLayerObj.current_area = "";
                        app.CheckoutChangeShopLayerObj.current_district = "";
                        app.CheckoutChangeShopLayerObj.current_shop = "";
                    }
                }
                else {
                    app.CheckoutChangeShopLayerObj.area_list = JSON.parse(JSON.stringify(app.$root.AllShopDistrictList));
                    app.CheckoutChangeShopLayerObj.district_list = [];
                    app.CheckoutChangeShopLayerObj.shop_list = [];
                    app.CheckoutChangeShopLayerObj.select_area = app.cart.shopArea;
                    app.CheckoutChangeShopLayerObj.select_district = app.cart.shopDistrict;
                    app.CheckoutChangeShopLayerObj.select_shop = app.cart.shop.shopCode_global;
                    app.CheckoutChangeShopLayerObj.current_area = app.cart.shopArea;
                    app.CheckoutChangeShopLayerObj.current_district = app.cart.shopDistrict;
                    app.CheckoutChangeShopLayerObj.current_shop = app.cart.shop.shopCode_global;                    
                }

                if (app.CheckoutChangeShopLayerObj.select_area != "")
                    app.ChangeShopChangeLayerShopDistrictAreaFilter();
            },
            openShopChangeLayerPanel() {
                var app = this;
                app.ChangeShopChangeLayerInit();
                app.FilterShopChangeLayerAllShopListAreaDistrict();

                app.CheckoutChangeShopLayerObj.showCheckoutChangeShopLayer = true;
                this.$root.setBodyOverflow(true);
            },
            CloseShopChangeLayerPanel() {
                this.CheckoutChangeShopLayerObj.showCheckoutChangeShopLayer = false;
                this.CheckoutChangeShopLayerObj.area_list = [];
                this.CheckoutChangeShopLayerObj.district_list = [];
                this.CheckoutChangeShopLayerObj.shop_list = [];
                this.CheckoutChangeShopLayerObj.select_area = "";
                this.CheckoutChangeShopLayerObj.select_district = "";
                this.CheckoutChangeShopLayerObj.select_shop = "";
                this.CheckoutChangeShopLayerObj.current_area = "";
                this.CheckoutChangeShopLayerObj.current_district = "";
                this.CheckoutChangeShopLayerObj.current_shop = "";

                this.$root.setBodyOverflow(false);
            },
            ShopChangeLayerEditConfirm() {
                var app = this;
                app.updateShopChangeCart(function (data) { app.ShopChangeLayerEditConfirmCb(data); });
            },
            updateShopChangeCart(cb, isReDo) {
                var app = this;
                app.info.loading = true;

                function reDoFn() {                    
                    app.CheckoutChangeShopLayerObj.select_area = app.CheckoutChangeShopLayerObj.current_area;
                    app.CheckoutChangeShopLayerObj.select_district = app.CheckoutChangeShopLayerObj.current_district;
                    app.CheckoutChangeShopLayerObj.select_shop = app.CheckoutChangeShopLayerObj.current_shop;
                    app.updateShopChangeCart(cb, true);
                }

                var select_shop = app.$root.getShopInfo(app.CheckoutChangeShopLayerObj.select_shop + "_" + app.$root.getCurrentOrderTypeSubfix);
                if (select_shop != null) {
                    if (app.$root.getCurrentOrderTypeSubfix == '3') {
                        app.cart.pickupShopCode = select_shop.shopCode_global;
                        app.cart.pickupShop = select_shop;
                    }
                    else {
                        app.cart.shop = select_shop;
                        app.cart.shopArea = app.CheckoutChangeShopLayerObj.select_area;
                        app.cart.shopDistrict = app.CheckoutChangeShopLayerObj.select_district;
                        app.$root.UpdateCartShopInfo(app.cart.shop);
                        app.$root.SetOrderShopMenuTime();
                    }

                    app.$root.setOrderTempInfoData();
                    app.cart.updateCartOrderInfo(app.info.order_temp_info, app.info.lang);
                    app.cart.saveCart();

                    app.$root
                        .wsPost(
                            app.info.wsUrl + "/order/updatecart",
                            app.info.lang,
                            JSON.stringify({ data: { token: app.cart.token, cart: app.cart } }),
                            (data) => {
                                app.$root.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                                console.log("updateShopChangeCart", data);
                                const data_msg = (data.message != undefined && data.message != null) ? data.message.replace("EXMessage: ", "") : "";
                                //$.extend(app.cart, data.cart);
                                //app.cart.saveCart();

                                if (data.status == 0) {
                                    $.extend(app.cart, data.cart);
                                    app.cart.saveCart();
                                    if (cb) cb(data);
                                    app.info.loading = false;

                                } else {

                                    if (isReDo) {
                                        //app.$root.alert(data.message);
                                    }
                                    else {

                                        if (data_msg == "item.updated") {
                                            app.$root.setConfirmMsg(
                                                app.label['checkout.shopChange.item.updated'],
                                                function () {
                                                    $.extend(app.cart, data.cart);
                                                    app.cart.saveCart();
                                                    app.$router.replace("menu");
                                                },
                                                reDoFn
                                            );
                                        }
                                        else if (data_msg == "shop.offline") {
                                            app.$root.alert("checkout.shopChange.shop.offline");
                                            reDoFn();
                                        }
                                        else {
                                            app.$root.alert(data.message);
                                            reDoFn();
                                        }

                                        
                                    }

                                    app.info.loading = false;
                                }

                                app.CheckoutListUpdate++;
                            }
                        )
                        .always(() => {
                            //app.info.loading = false;
                        })
                        .fail(() => {
                            //app.$root.alert("Fail!");
                            app.$root.alert("common_fail_message");

                            // clear cart and redirect to select brand when fail
                            app.cart.clearCart();
                            app.$router.push("/");
                        });
                }
                else {
                    app.info.loading = false;
                    //app.$root.alert("shop_not_found");
                    app.$root.alert('checkout_please_select_pickupShop');
                }
            },
            ShopChangeLayerEditConfirmCb(data) {
                //console.log("data", data);
                var app = this;

                if (data.status == 0) {
                    app.displayShop = app.$root.getShopInfo(app.cart.shop.shopCode);
                    app.CloseShopChangeLayerPanel(); // close layer when updatecart successfully
                } else {
                    app.$root.alert(data.detail);
                }
            },
            ShopChangeLayerShopSelect(s) {
                if (s.isOpen) {
                    this.CheckoutChangeShopLayerObj.select_shop = s.shopCode_global;
                }
            },
            ShopChangeLayerShopDistrictArea(ev) {
                this.CheckoutChangeShopLayerObj.select_area = ev.target.value + "";
                this.CheckoutChangeShopLayerObj.select_district = "";
                this.CheckoutChangeShopLayerObj.district_list = [];
                if (this.CheckoutChangeShopLayerObj.select_area != "")
                    this.ChangeShopChangeLayerShopDistrictAreaFilter();

                this.FilterShopChangeLayerAllShopListAreaDistrict();
            },
            ChangeShopChangeLayerShopDistrictAreaFilter() {
                var app = this;
                app.$root.ChangeSelectShopDistrictAreaFilterFill(app.CheckoutChangeShopLayerObj.select_area, app.CheckoutChangeShopLayerObj.district_list);
            },
            ShopChangeLayerShopDistrictAreaDistrict(ev) {
                this.CheckoutChangeShopLayerObj.select_district = ev.target.value + "";
                this.FilterShopChangeLayerAllShopListAreaDistrict();
            },
            FilterShopChangeLayerAllShopListAreaDistrict() {
                var app = this;
                app.CheckoutChangeShopLayerObj.shop_list = [];

                if (app.CheckoutChangeShopLayerObj.shop_list_all.length <= 0) {
                    var temp_shop = null;
                    var o = null;

                    if (app.$root.getCurrentOrderTypeShopFilterSubfix == '3') {
                        temp_shop = app.$root.AllShopList.filter(s2 => (s2.shopType != 'shopping' && s2.visible == 'y' && s2.shopCode.includes("_" + app.$root.getCurrentOrderTypeShopFilterSubfix)));
                        if (temp_shop.length > 0) {
                            app.CheckoutChangeShopLayerObj.shop_list_all = temp_shop.slice();
                        }
                        $.each(app.CheckoutChangeShopLayerObj.shop_list_all, (i, s) => {
                            s.isOpen = true;
                            s.isOnline = true;
                            s.distance = -1; 
                        });
                    }
                    else {
                        var check_date = moment(app.$root.OrderDateSelectMenuTime);
                        var check_time = check_date.hour() * 100 + check_date.minute();
                        $.each(app.$root.LLShopList, (i, s1) => {
                            temp_shop = app.$root.AllShopList.filter(s2 => (s2.shopType == app.$root.info.order_temp_info.order_mode && (s1.shopCode + "_" + app.$root.getCurrentOrderTypeShopFilterSubfix == s2.shopCode)));
                            if (temp_shop.length > 0) {
                                o = temp_shop[0];
                                o.isOpen = false;
                                o.isOnline = s1.isOnline;
                                //if (o.visible != "y") o.isOnline = false; // not checking visible on tenren
                                o.distance = -1; // add distance on 20251217

                                if (o.isOnline) {
                                    o.isOpen = app.cart.getShopOpen(o, app.$root.OrderDateSelectIsHoliday, check_date, check_time);
                                }

                                app.CheckoutChangeShopLayerObj.shop_list_all.push(o);
                            }
                        });
                    }
                }

                app.CheckoutChangeShopLayerObj.shop_list = JSON.parse(JSON.stringify(app.CheckoutChangeShopLayerObj.shop_list_all));

                if (app.CheckoutChangeShopLayerObj.select_area != "") {
                    app.CheckoutChangeShopLayerObj.shop_list = app.CheckoutChangeShopLayerObj.shop_list.filter(s2 => (s2.areaCode == app.CheckoutChangeShopLayerObj.select_area));
                }

                if (app.CheckoutChangeShopLayerObj.select_district != "") {
                    app.CheckoutChangeShopLayerObj.shop_list = app.CheckoutChangeShopLayerObj.shop_list.filter(s2 => (s2.districtCode == app.CheckoutChangeShopLayerObj.select_district));
                }

                // not display visible shop for tenren
                app.CheckoutChangeShopLayerObj.shop_list = app.CheckoutChangeShopLayerObj.shop_list.filter(s2 => (s2.visible == "y"));
    
                // add google map distance on 20251217
                if (app.$root.getCurrentOrderTypeShopFilterSubfix != '3') {
                    app.$root.setShopListDistance(app.CheckoutChangeShopLayerObj.shop_list);
                }

                app.CheckoutChangeShopLayerObj.shop_list = multiSort(app.CheckoutChangeShopLayerObj.shop_list, { "isOpen": "desc", "distance": "asc" });

                // add test_pickupShop to the last
                if (app.$root.getCurrentOrderTypeShopFilterSubfix == '3') {
                    if (app.$root.info.order_setting.test_pickupShop != undefined && app.$root.info.order_setting.test_pickupShop != null && app.$root.info.order_setting.test_pickupShop.length > 0) {
                        $.each(app.$root.info.order_setting.test_pickupShop, (i, s1) => {
                            temp_shop = app.$root.AllShopList.filter(s2 => (s2.shopCode_global.toLowerCase() == s1.toLowerCase()));
                            if (temp_shop.length > 0) {
                                temp_shop[0].isOpen = true;
                                temp_shop[0].isOnline = true;
                                temp_shop[0].distance = -1; 
                                app.CheckoutChangeShopLayerObj.shop_list.push(temp_shop[0]);
                            }
                        });
                    }
                }
            },
            /* changeShop end */

            disableDiscountBtnClick() {
                var app = this;
                if (!app.cart.disableDiscount) {
                    app.$root.setConfirmMsg(app.label['checkout_disableDiscountBtn_confirm_text'], function () {
                        app.cart.disableDiscount = true;
                        app.cart.discounts = [];
                        app.cart.coupons = [];
                        app.cart.couponCode = null;
                        app.cart.couponPromoteCode = "";
                        app.cart.paymentCampaign = null;
                        app.CheckoutSelectCouponLayerObj.use_coupon = [];
                        app.CheckoutSelectCouponLayerObj.select_coupon = [];
                        app.UseDiscountCodeObj.inUse = false;
                        app.UseDiscountCodeObj.codeUse = "";
                        app.UseDiscountCodeObj.isError = false;
                        //var discountCode_obj = app.$el.querySelector("#checkout_cart_discount_code");
                        app.$root.updateCart(function () {
                            //discountCode_obj.value = "";
                            app.getPaymethodJson(null, false);
                            app.cart.saveCart();
                        }, false); 
                    }, undefined);
                }
                else {
                    app.cart.disableDiscount = false;
                    app.$root.updateCart(function () {
                        app.getPaymethodJson(null, false);
                        app.cart.saveCart();
                    }, false); 
                }
            },

            getPaymethodJson(method, init) {
                var app = this;
                var reload = false;
                if (app.cart.paymentCampaign == undefined || app.cart.paymentCampaign == '')
                    app.cart.paymentCampaign = null;

                console.log('init ', init);
                console.log('app.payMethodList_method ', app.payMethodList_method);
                console.log('app.cart.paymentCampaign ', app.cart.paymentCampaign);

                if (!init) {
                    if (app.payMethodList_method != app.cart.paymentCampaign)
                        reload = true;
                }
                else {
                    reload = true;
                }
                    
                if (reload) {
                    if ((method == null || method == '') && init)
                        method = app.cart.paymentCampaign;

                    if (method != null && method != '') {
                        $.ajax({
                            url: "/files/payMethod_" + method + ".json",
                            type: 'GET',
                            async: false,
                            success: function (data) {
                                try {
                                    if (typeof data === 'string')
                                        data = JSON.parse(data);
                                    app.payMethodList = data.list;
                                    app.payMethodList_method = method;
                                    if (app.payMethodList.length > 0) {
                                        app.setPayMethodNormal(app.payMethodList[0]);
                                    }
                                    else {
                                        app.getPaymethodJson('', false);
                                    }
                                } catch (e) {
                                    console.log('getPaymethodJson ' + method, e);
                                    app.getPaymethodJson('', false);
                                }
                            },
                            error: function (e) {
                                console.log('getPaymethodJson ' + method, e);
                            }
                        });
                    }
                    else {
                        $.ajax({
                            url: "/files/payMethod.json",
                            type: 'GET',
                            async: false,
                            success: function (data) {
                                app.payMethodList = data.list;
                                app.payMethodList_method = null;
                                if (app.payMethodList.length > 0) {
                                    if (app.cart.tempPaymentMethod != null) {
                                        app.setPayMethodNormal(getPayMethodObj(app.cart.tempPaymentMethod));
                                    } else {
                                        app.setPayMethodNormal(app.payMethodList[0]);
                                    }
                                }
                            },
                            error: function (e) {
                                console.log('getPaymethodJson ', e);
                            }
                        });
                    }
                }
            }

        },
    };
</script>

